import React, { useState, useEffect, useRef } from "react";
import { formatOrderPhoneInput } from '../utils/orderPhoneInput';
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import {
  FiCalendar,
  FiTrash2,
  FiInfo,
  FiMapPin,
  FiCheckCircle,
  FiBox,
  FiShield,
  FiPhone,
  FiPlusCircle,
  FiArrowRight,
  FiCheck,
  FiTruck,
  FiZap,
} from "react-icons/fi";
import { LuClock3 } from "react-icons/lu";
import Input from "../components/Input";
import { MdElectricScooter, MdMyLocation, MdTwoWheeler } from "react-icons/md";
import API_URL from "../config/config";
import { IoIosClose } from "react-icons/io";
import Button from "../components/Button";
import SecurityFeeInfoButton from "../components/SecurityFeeInfoButton";
import NearbyPlacesAutocomplete from "../components/NearbyPlacesAutocomplete";
import ServiceabilityModal from "../components/ServiceabilityModal";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { ref, set } from "firebase/database";
import { db } from "../config";
import { useNavigate } from "react-router-dom";
import { clearBookingDraft, readBookingDraft } from "../utils/bookingDraft";
import {
  ORDER_WEIGHT_OPTIONS,
  addMinutesToTimeWithinDay,
  compareTimeValues,
  getLatestStartTimeForDuration,
  normalizeLocationsForPayload,
} from "../utils/orderFlow";
import {
  fetchScheduledOrderMinimumTimes,
  PICKUP_SCHEDULE_MINUTES,
} from "../utils/scheduledOrderTime";
import {
  getCachedPriceConfiguration,
  preloadPriceConfiguration,
} from "../utils/priceConfigurationCache";
import { getPreciseCurrentLocation } from "../utils/getPreciseCurrentLocation";
import { checkAddressServiceability } from "../utils/addressServiceability";
import { getCurrentLocationAddressFromGeocodeResults } from "../utils/addressFormatting";
import {
  areLocationsSame,
  validateDifferentPickupAndDrop,
  validateUniqueLocations,
} from "../utils/locationValidation";
import { dispatchWebsiteNotification } from "../utils/browserNotifications";
import {
  checkoutOrderSettings,
  completeOnlineOrder,
} from "../utils/onlineOrderPayment";

const padDatePart = (value) => String(value).padStart(2, "0");
const toTimeInputValueFromDate = (date) =>
  `${padDatePart(date.getHours())}:${padDatePart(date.getMinutes())}`;

const toDateInputValue = (date) =>
  `${date.getFullYear()}-${padDatePart(date.getMonth() + 1)}-${padDatePart(
    date.getDate(),
  )}`;

const addDays = (date, days) => {
  const nextDate = new Date(date);
  nextDate.setDate(nextDate.getDate() + days);
  return nextDate;
};

const QUICK_PACKAGE_OPTIONS = [
  "Documents",
  "Flowers",
  "Food",
  "Clothes",
  "Medicines",
  "Groceries",
  "Cake",
  "Parcel",
];

const DELIVERY_TYPE_FEATURES = {
  now: ["Fast pickup", "Instant dispatch"],
  flexible: ["Pickup in 2.5 hrs", "Delivery in 4-5 hrs"],
  scheduled: ["Pickup on time", "Flexible window"],
};

const DUPLICATE_ADDRESS_SIDE_MESSAGE =
  "This address is already selected in another stop. Please choose a different one.";
const DUPLICATE_ADDRESS_SNACKBAR_MESSAGE = "Can't use same address.";
const FLEXIBLE_DELIVERY_UNAVAILABLE_MESSAGE =
  "Orders in this category can be created from 8am to 6pm.";

const CreateOrder = () => {
  const navigate = useNavigate(); // Add this for navigation
  const [paymentAddress, setPaymentAddress] = useState();
  const [userData, setUserData] = useState(null);
  const [isFetchingLocation, setIsFetchingLocation] = useState(false);
  // Add this state near your other state declarations
  const [walletDue, setWalletDue] = useState(0);
  const [hasWalletDue, setHasWalletDue] = useState(false);
  const [showWalletDueInfo, setShowWalletDueInfo] = useState(false);
  const [bookingDraft] = useState(() => readBookingDraft());
  const weight = ORDER_WEIGHT_OPTIONS;
  const addressInitialState = {
    text: "",
    place_id: "",
    latitude: 0.0,
    longitude: 0.0,
    building_and_flat: "",
    floor_and_wing: "",
    key: "",
    instructions: "",
    phone_number: "",
    address: "",
    name: "",
    date: "",
    time: "",
    fromtime: "",
    totime: "",
  };
  function formatPhoneNumber(input) {
    const rawInput = String(input || "");
    let numericInput = rawInput.replace(/\D/g, "");

    if (rawInput.includes("+91") && numericInput.startsWith("91")) {
      numericInput = numericInput.slice(2);
    } else if (numericInput.startsWith("91") && numericInput.length > 10) {
      numericInput = numericInput.slice(2);
    }
    if (numericInput.length > 10) {
      numericInput = numericInput.slice(0, 10);
    }

    let formattedNumber = "+91";
    if (numericInput.length > 0) {
      formattedNumber += " ";
    }
    if (numericInput.length > 5) {
      formattedNumber += `${numericInput.slice(0, 5)} ${numericInput.slice(5, 10)}`;
    } else {
      formattedNumber += numericInput;
    }

    return formattedNumber;
  }

  function getPhoneInputValue(input) {
    const rawInput = String(input || "");
    let numericInput = rawInput.replace(/\D/g, "");

    if (rawInput.includes("+91") && numericInput.startsWith("91")) {
      numericInput = numericInput.slice(2);
    } else if (numericInput.startsWith("91") && numericInput.length > 10) {
      numericInput = numericInput.slice(2);
    }
    if (numericInput.length > 10) {
      numericInput = numericInput.slice(0, 10);
    }

    if (numericInput.length > 5) {
      return `${numericInput.slice(0, 5)} ${numericInput.slice(5, 10)}`;
    }
    return numericInput;
  }

  function renderPrefixedPhoneInput({
    value,
    onChange,
    label,
    id,
    error,
    placeholder = "Enter your 10 digit mobile number",
    required = true,
  }) {
    return (
      <div className="w-full flex flex-col items-start">
        <label htmlFor={id} className="pb-1 text-sm lg:text-base">
          {label}
        </label>
        <div
          className={`flex w-full overflow-hidden rounded-xl border-2 ${error ? "border-red-500" : "border-accentYellow"}`}
        >
          <span className="flex min-w-[72px] items-center justify-center border-r border-[#e5e7eb] bg-[#fff6df] px-3 text-[14px] font-medium text-[#191919]">
            +91
          </span>
          <input
            required={required}
            onChange={(e) => onChange(formatOrderPhoneInput(e.target.value, value))}
            value={getPhoneInputValue(value)}
            className="w-full outline-none bg-white px-4 py-3 text-[14px] text-[#1e2430] placeholder:text-[#8f96aa]"
            type="text"
            placeholder={placeholder}
            id={id}
            autoComplete="tel-national"
            inputMode="numeric"
          />
        </div>
        {error ? <p className="mt-1 text-xs text-red-500">{error}</p> : null}
      </div>
    );
  }

  const handleGetCurrentLocation = () => {
    if (navigator.geolocation) {
      setIsFetchingLocation(true);
      getPreciseCurrentLocation({
        desiredAccuracy: 80,
        timeoutMs: 12000,
        maximumAge: 0,
      })
        .then(async (position) => {
          const { latitude, longitude } = position.coords;
          const verification = await checkAddressServiceability({
            latitude,
            longitude,
          });
          if (!verification.serviceable) {
            openServiceabilityModal();
            setIsFetchingLocation(false);
            return;
          }

          // Reverse geocode to get address
          const geocoder = window.google?.maps?.Geocoder
            ? new window.google.maps.Geocoder()
            : null;
          if (!geocoder) {
            const nextPickup = {
              ...pickup,
              text: `${latitude}, ${longitude}`,
              address: `${latitude}, ${longitude}`,
              latitude,
              longitude,
              place_id: "",
              key: uuidv4(),
            };
            if (hasDuplicateLocationSelection(nextPickup, "pickup")) {
              clearLocationSearch("pickup");
              showDuplicateAddressFeedback();
              setIsFetchingLocation(false);
              return;
            }
            setPickup(nextPickup);
            clearFieldErrors("pickup_search");
            setIsFetchingLocation(false);
            return;
          }

          const latlng = { lat: latitude, lng: longitude };

          geocoder.geocode({ location: latlng }, (results, status) => {
            if (status === "OK" && results[0]) {
              const address = getCurrentLocationAddressFromGeocodeResults(
                results,
                `${latitude}, ${longitude}`,
              );
              const key = uuidv4();
              const nextPickup = {
                ...pickup,
                text: address,
                address,
                latitude: latitude,
                longitude: longitude,
                place_id: results[0]?.place_id || "",
                key: key,
              };
              if (hasDuplicateLocationSelection(nextPickup, "pickup")) {
                clearLocationSearch("pickup");
                showDuplicateAddressFeedback();
                setIsFetchingLocation(false);
                return;
              }
              setPickup(nextPickup);
              clearFieldErrors("pickup_search");
            } else {
              const nextPickup = {
                ...pickup,
                text: `${latitude}, ${longitude}`,
                address: `${latitude}, ${longitude}`,
                latitude,
                longitude,
                place_id: "",
                key: uuidv4(),
              };
              if (hasDuplicateLocationSelection(nextPickup, "pickup")) {
                clearLocationSearch("pickup");
                showDuplicateAddressFeedback();
                setIsFetchingLocation(false);
                return;
              }
              setPickup(nextPickup);
              clearFieldErrors("pickup_search");
              toast.error("Failed to get address from location");
            }
            setIsFetchingLocation(false);
          });
        })
        .catch((error) => {
          console.error("Geolocation error:", error);
          const errorMessage =
            error.code === error.PERMISSION_DENIED
              ? "Please allow location access to use your current pickup."
              : error.code === error.TIMEOUT ||
                  /timed out/i.test(error.message || "")
                ? "Getting your location timed out. Please try again."
                : "Failed to get current location. Please try again.";
          toast.error(errorMessage);
          setIsFetchingLocation(false);
        });
    } else {
      toast.error("Geolocation is not supported by this browser.");
    }
  };

  const [pickup, setPickup] = useState(() =>
    bookingDraft
      ? {
          ...addressInitialState,
          ...bookingDraft.pickup,
          key: uuidv4(),
          address: bookingDraft.pickup.address || bookingDraft.pickup.text,
        }
      : addressInitialState,
  );
  const [drop, setDrop] = useState(() =>
    bookingDraft
      ? {
          ...addressInitialState,
          ...bookingDraft.drop,
          key: uuidv4(),
          address: bookingDraft.drop.address || bookingDraft.drop.text,
        }
      : addressInitialState,
  );
  const [show, setShow] = useState(false);
  const initialFormState = {
    delivery_type: ["now", "flexible", "scheduled"].includes(
      bookingDraft?.deliveryType,
    )
      ? bookingDraft.deliveryType
      : "now",
    parcel_weight: weight[0],
    phone_number: "",
    payment_method: "cod",
    package: "",
    parcel_value: "",
    vehicle: "scooty",
  };
  const [formState, setFormState] = useState(initialFormState);
  const [priceData, setPriceData] = useState(() =>
    getCachedPriceConfiguration(),
  );
  const [payment, setPayment] = useState("cod");
  const [droplocations, setDroplocations] = useState([]);
  const [amount, setAmount] = useState(0.0);
  const [orderAmount, setOrderAmount] = useState(0.0);
  const [securityFeeAmount, setSecurityFeeAmount] = useState(0.0);
  const [flexibleDeliveryDiscountAmount, setFlexibleDeliveryDiscountAmount] =
    useState(0.0);
  const [showNote, setShowNote] = useState(false);
  const [isCalculating, setIsCalculating] = useState(false);
  const [isPlacingOrder, setIsPlacingOrder] = useState(false); // New state for order placement
  const [isPreparingOrder, setIsPreparingOrder] = useState(false);
  const [showPriceDetails, setShowPriceDetails] = useState(false); // For mobile view
  const [formErrors, setFormErrors] = useState({}); // For form validation
  const [showServiceabilityModal, setShowServiceabilityModal] = useState(false);
  const [scheduledSegmentMinutes, setScheduledSegmentMinutes] = useState([]);
  const pricingRequestIdRef = useRef(0);
  const orderPlacementLockRef = useRef(false);
  const orderPreparationLockRef = useRef(false);
  const [currentTimeTick, setCurrentTimeTick] = useState(Date.now());

  useEffect(() => {
    if (!isPlacingOrder) {
      orderPlacementLockRef.current = false;
    }
  }, [isPlacingOrder]);
  const isFlexibleBookingOpen = () => {
    const istNow = new Date(Date.now() + 5.5 * 60 * 60 * 1000);
    const istHour = istNow.getUTCHours();
    return istHour >= 8 && istHour < 18;
  };
  const flexibleDeliveryAvailable = (() => {
    const istNow = new Date(currentTimeTick + 5.5 * 60 * 60 * 1000);
    const istHour = istNow.getUTCHours();
    return istHour >= 8 && istHour < 18;
  })();
  const configuredFlexibleDiscountPercent = Number(
    priceData?.flexibleDeliveryDiscountPercent ??
      priceData?.flexible_delivery_discount_percent ??
      0,
  );
  const flexibleDiscountPercent = Number.isFinite(
    configuredFlexibleDiscountPercent,
  )
    ? Math.min(Math.max(configuredFlexibleDiscountPercent, 0), 100)
    : 0;
  const flexibleDiscountLabel = `${
    Number.isInteger(flexibleDiscountPercent)
      ? flexibleDiscountPercent
      : flexibleDiscountPercent.toFixed(2).replace(/\.0+$/, "")
  }% off`;
  const pickupDateMin = toDateInputValue(new Date());
  const pickupDateMax = toDateInputValue(addDays(new Date(), 3));
  const hasPrimaryRoute =
    Boolean(pickup.latitude) &&
    Boolean(pickup.longitude) &&
    Boolean(drop.latitude) &&
    Boolean(drop.longitude);
  const dropRouteSignature = droplocations
    .map(
      (location) =>
        `${location?.key || ""}:${Number(location?.latitude) || 0},${
          Number(location?.longitude) || 0
        }`,
    )
    .join("|");
  const hasPendingDropPoints = droplocations.some(
    (location) => !location?.latitude || !location?.longitude,
  );
  const hasFareSummary =
    !hasPendingDropPoints && (hasPrimaryRoute || isCalculating);
  const fareDisplayLabel =
    isCalculating && amount <= 0 ? "Calculating..." : `₹${amount.toFixed(0)}`;
  const canAutoUpdateFare =
    Boolean(pickup.latitude) &&
    Boolean(pickup.longitude) &&
    Boolean(drop.latitude) &&
    Boolean(drop.longitude) &&
    !hasPendingDropPoints;
  const scheduledSegmentSignature = (scheduledSegmentMinutes || [])
    .map((value) => {
      const numericValue = Number(value);
      return Number.isFinite(numericValue) && numericValue > 0
        ? numericValue
        : 0;
    })
    .join("|");

  const syncSharedScheduledDate = (dateValue) => {
    setPickup((current) => ({ ...current, date: dateValue }));
    setDrop((current) => ({ ...current, date: dateValue }));
    setDroplocations((current) =>
      current.map((location) => ({
        ...location,
        date: dateValue,
      })),
    );
  };

  const openServiceabilityModal = () => {
    setShowServiceabilityModal(true);
  };

  const showDuplicateAddressFeedback = () => {
    toast.dismiss("duplicate-address-side");
    toast.dismiss("duplicate-address-snackbar");
    toast.error(DUPLICATE_ADDRESS_SIDE_MESSAGE, {
      position: "top-right",
      toastId: "duplicate-address-side",
    });
    toast.error(DUPLICATE_ADDRESS_SNACKBAR_MESSAGE, {
      position: "bottom-center",
      autoClose: 5000,
      toastId: "duplicate-address-snackbar",
    });
  };

  const getComparableLocationsForTarget = (targetType, index = null) => {
    if (targetType === "pickup") {
      return [drop, ...droplocations];
    }

    if (targetType === "drop") {
      return [pickup, ...droplocations];
    }

    if (targetType === "droppoint" && index !== null) {
      return [
        pickup,
        drop,
        ...droplocations.filter((_, itemIndex) => itemIndex !== index),
      ];
    }

    return [];
  };

  const hasDuplicateLocationSelection = (
    candidateLocation,
    targetType,
    index = null,
  ) =>
    getComparableLocationsForTarget(targetType, index).some((location) =>
      areLocationsSame(candidateLocation, location),
    );

  const applySelectedLocation = (currentLocation, selectedLocation) => {
    const selectedAddressText =
      selectedLocation.description || selectedLocation.address || "";

    return {
      ...currentLocation,
      latitude: selectedLocation.latitude,
      longitude: selectedLocation.longitude,
      text: selectedAddressText,
      address: selectedAddressText,
      place_id: selectedLocation.place_id || selectedLocation.placeId || "",
      key: currentLocation.key || uuidv4(),
    };
  };

  const resetLocationSearch = (currentLocation, text) => ({
    ...currentLocation,
    text,
    address: text,
    place_id: "",
    latitude: 0,
    longitude: 0,
  });

  const getPhoneDigits = (value) => {
    const rawValue = String(value || "");
    let digits = rawValue.replace(/\D/g, "");

    if (rawValue.includes("+91") && digits.startsWith("91")) {
      digits = digits.slice(2);
    } else if (digits.startsWith("91") && digits.length > 10) {
      digits = digits.slice(2);
    }

    return digits;
  };

  const isValidPhoneNumber = (value) => {
    const digits = getPhoneDigits(value);
    return digits.length === 10;
  };

  const updatePhoneFieldError = (fieldKey, value) => {
    setFormErrors((current) => {
      const nextErrors = { ...current };
      if (isValidPhoneNumber(value)) {
        delete nextErrors[fieldKey];
      } else {
        nextErrors[fieldKey] = "Please enter a valid 10-digit mobile number";
      }
      return nextErrors;
    });
  };

  const clearFieldErrors = (...keys) => {
    const validKeys = keys.filter(Boolean);
    if (!validKeys.length) return;

    setFormErrors((current) => {
      const nextErrors = { ...current };
      validKeys.forEach((key) => {
        delete nextErrors[key];
      });
      return nextErrors;
    });
  };

  const getDropPointErrorKey = (field, index) => `droppoint_${field}_${index}`;

  const preventManualTimeTyping = (event) => {
    event.preventDefault();
  };

  const getSegmentMinimumMinutes = (segmentIndex) => {
    const value = Number(scheduledSegmentMinutes?.[segmentIndex]);
    return Number.isFinite(value) && value > 0 ? value : null;
  };

  const getCurrentPickupFromTime = (
    dateValue = pickup.date || pickupDateMin,
  ) => {
    if (!dateValue || dateValue !== pickupDateMin) {
      return "";
    }

    return toTimeInputValueFromDate(new Date(currentTimeTick));
  };

  const getRequiredFromTimeForStop = (type, index = null) => {
    if (type === "pickup") {
      return getCurrentPickupFromTime();
    }

    if (type === "drop") {
      return pickup.totime || "";
    }

    if (type === "droppoint" && index !== null) {
      if (index === 0) {
        return drop.totime || pickup.totime || "";
      }
      return droplocations[index - 1]?.totime || "";
    }

    return "";
  };

  const getMinimumToTimeForStop = (
    type,
    index = null,
    fromTimeOverride = "",
  ) => {
    const fromTime =
      fromTimeOverride ||
      (type === "pickup"
        ? pickup.fromtime
        : type === "drop"
          ? drop.fromtime
          : index !== null
            ? droplocations[index]?.fromtime
            : "");

    if (!fromTime) return "";

    const minimumMinutes =
      type === "pickup"
        ? PICKUP_SCHEDULE_MINUTES
        : type === "drop"
          ? getSegmentMinimumMinutes(0)
          : index !== null
            ? getSegmentMinimumMinutes(index + 1)
            : null;

    if (
      !Number.isFinite(Number(minimumMinutes)) ||
      Number(minimumMinutes) <= 0
    ) {
      return "";
    }

    return addMinutesToTimeWithinDay(fromTime, minimumMinutes);
  };

  const getMaximumFromTimeForStop = (type, index = null) => {
    const durationMinutes =
      type === "pickup"
        ? PICKUP_SCHEDULE_MINUTES
        : type === "drop"
          ? getSegmentMinimumMinutes(0)
          : index !== null
            ? getSegmentMinimumMinutes(index + 1)
            : null;

    if (
      !Number.isFinite(Number(durationMinutes)) ||
      Number(durationMinutes) <= 0
    ) {
      return "";
    }

    return getLatestStartTimeForDuration(durationMinutes);
  };

  const getDropTimeErrorMessage = (minimumMinutes) => {
    return Number.isFinite(Number(minimumMinutes)) && Number(minimumMinutes) > 0
      ? `To time must be at least ${Number(minimumMinutes)} minutes after from time`
      : "Please select a valid time";
  };

  const buildScheduledRouteTimeState = (
    segmentMinutes,
    pickupState = pickup,
    dropState = drop,
    dropLocationsState = droplocations,
    forceRouteWindows = false,
  ) => {
    if (formState.delivery_type !== "scheduled") {
      return null;
    }

    const nextPickup = { ...pickupState };
    const nextDrop = { ...dropState };
    const nextDroplocations = (dropLocationsState || []).map((location) => ({
      ...location,
    }));

    const pickupRequiredFrom = getCurrentPickupFromTime(
      nextPickup.date || pickupDateMin,
    );
    if (
      pickupRequiredFrom &&
      (!nextPickup.fromtime ||
        compareTimeValues(nextPickup.fromtime, pickupRequiredFrom) === -1)
    ) {
      nextPickup.fromtime = pickupRequiredFrom;
      nextPickup.time = pickupRequiredFrom;
    }

    const pickupMinimumTo = nextPickup.fromtime
      ? addMinutesToTimeWithinDay(nextPickup.fromtime, PICKUP_SCHEDULE_MINUTES)
      : "";
    if (
      pickupMinimumTo &&
      (forceRouteWindows ||
        !nextPickup.totime ||
        compareTimeValues(nextPickup.totime, pickupMinimumTo) === -1)
    ) {
      nextPickup.totime = pickupMinimumTo;
    }

    const firstRequiredFrom = nextPickup.totime || pickupMinimumTo;
    if (
      firstRequiredFrom &&
      (forceRouteWindows ||
        !nextDrop.fromtime ||
        compareTimeValues(nextDrop.fromtime, firstRequiredFrom) === -1)
    ) {
      nextDrop.fromtime = firstRequiredFrom;
      nextDrop.time = firstRequiredFrom;
    }

    const firstSegmentMinutes = Number(segmentMinutes?.[0]);
    const dropExactToTime =
      nextDrop.fromtime &&
      Number.isFinite(firstSegmentMinutes) &&
      firstSegmentMinutes > 0
        ? addMinutesToTimeWithinDay(nextDrop.fromtime, firstSegmentMinutes)
        : "";
    if (dropExactToTime) {
      nextDrop.totime = dropExactToTime;
    }

    let previousToTime =
      nextDrop.totime ||
      dropExactToTime ||
      nextDrop.fromtime ||
      firstRequiredFrom;

    nextDroplocations.forEach((location, index) => {
      if (
        previousToTime &&
        (forceRouteWindows ||
          !location.fromtime ||
          compareTimeValues(location.fromtime, previousToTime) === -1)
      ) {
        location.fromtime = previousToTime;
        location.time = previousToTime;
      }

      const segmentValue = Number(segmentMinutes?.[index + 1]);
      const exactToTime =
        location.fromtime && Number.isFinite(segmentValue) && segmentValue > 0
          ? addMinutesToTimeWithinDay(location.fromtime, segmentValue)
          : "";

      if (exactToTime) {
        location.totime = exactToTime;
        previousToTime = exactToTime;
      } else {
        previousToTime = location.totime || location.fromtime || previousToTime;
      }
    });

    return {
      pickup: nextPickup,
      drop: nextDrop,
      droplocations: nextDroplocations,
    };
  };

  const syncScheduledRouteTimesFromPickup = (fromtime) => {
    const syncedTimeState = buildScheduledRouteTimeState(
      scheduledSegmentMinutes,
      { ...pickup, fromtime, time: fromtime },
      drop,
      droplocations,
      true,
    );

    if (!syncedTimeState) return;
    setPickup(syncedTimeState.pickup);
    setDrop(syncedTimeState.drop);
    setDroplocations(syncedTimeState.droplocations);
  };

  const handleDeliveryTypeChange = (deliveryType) => {
    setFormState((current) => ({
      ...current,
      delivery_type: deliveryType,
    }));

    if (deliveryType === "scheduled") {
      const nextPickupDate = pickup.date || pickupDateMin;
      syncSharedScheduledDate(nextPickupDate);
      setPickup((current) => ({
        ...current,
        fromtime: current.fromtime || "",
        totime: current.totime || "",
      }));
    } else {
      if (deliveryType === "flexible") {
        setPaymentAddress((current) =>
          droplocations.some((location) => location.key === current?.key)
            ? drop
            : current,
        );
      }
      setScheduledSegmentMinutes([]);
      setPickup((current) => ({
        ...current,
        date: "",
        time: "",
        fromtime: "",
        totime: "",
      }));
      setDrop((current) => ({
        ...current,
        date: "",
        time: "",
        fromtime: "",
        totime: "",
      }));
      setDroplocations((current) =>
        deliveryType === "flexible"
          ? []
          : current.map((location) => ({
              ...location,
              date: "",
              time: "",
              fromtime: "",
              totime: "",
            })),
      );
    }
  };

  const handlePickupDateChange = (value) => {
    syncSharedScheduledDate(value);
    clearFieldErrors("pickup_date");
  };

  const clearLocationSearch = (type, index = null) => {
    if (type === "pickup") {
      setPickup((current) => resetLocationSearch(current, ""));
      clearFieldErrors("pickup_search");
      resetFareSummary();
      return;
    }

    if (type === "drop") {
      setDrop((current) => resetLocationSearch(current, ""));
      clearFieldErrors("drop_search");
      resetFareSummary();
      return;
    }

    if (type === "droppoint" && index !== null) {
      setDroplocations((current) =>
        current.map((item, itemIndex) =>
          itemIndex === index ? resetLocationSearch(item, "") : item,
        ),
      );
      clearFieldErrors(getDropPointErrorKey("search", index));
      resetFareSummary();
    }
  };

  const resetFareSummary = () => {
    setAmount(0);
    setOrderAmount(0);
    setSecurityFeeAmount(0);
    setFlexibleDeliveryDiscountAmount(0);
    setShowPriceDetails(false);
    setScheduledSegmentMinutes([]);
  };

  useEffect(() => {
    const timer = window.setInterval(() => {
      setCurrentTimeTick(Date.now());
    }, 30000);

    return () => window.clearInterval(timer);
  }, []);

  useEffect(() => {
    if (formState.delivery_type !== "scheduled") {
      return;
    }

    const pickupRequiredFrom = getRequiredFromTimeForStop("pickup");
    const pickupMinimumTo = getMinimumToTimeForStop(
      "pickup",
      null,
      pickup.fromtime,
    );
    const pickupMaximumFrom = getMaximumFromTimeForStop("pickup");

    setPickup((current) => {
      const nextState = { ...current };

      if (
        pickupRequiredFrom &&
        (!current.fromtime ||
          compareTimeValues(current.fromtime, pickupRequiredFrom) === -1)
      ) {
        nextState.fromtime = pickupRequiredFrom;
      }

      if (
        pickupMaximumFrom &&
        nextState.fromtime &&
        compareTimeValues(nextState.fromtime, pickupMaximumFrom) === 1
      ) {
        nextState.fromtime = pickupMaximumFrom;
      }

      const recalculatedPickupMinTo = getMinimumToTimeForStop(
        "pickup",
        null,
        nextState.fromtime,
      );

      if (
        recalculatedPickupMinTo &&
        (!nextState.totime ||
          compareTimeValues(nextState.totime, recalculatedPickupMinTo) === -1)
      ) {
        nextState.totime = recalculatedPickupMinTo;
        nextState.time = nextState.fromtime;
      }

      return nextState;
    });

    const pickupToTime = pickup.totime || pickupMinimumTo;
    if (pickupToTime) {
      setDrop((current) => {
        const nextState = { ...current };
        if (
          !nextState.fromtime ||
          compareTimeValues(nextState.fromtime, pickupToTime) === -1
        ) {
          nextState.fromtime = pickupToTime;
          nextState.time = pickupToTime;
        }
        const minimumDropTo = getMinimumToTimeForStop(
          "drop",
          null,
          nextState.fromtime,
        );
        if (
          minimumDropTo &&
          (!nextState.totime ||
            compareTimeValues(nextState.totime, minimumDropTo) === -1)
        ) {
          nextState.totime = minimumDropTo;
        }
        return nextState;
      });
    }

    setDroplocations((current) =>
      current.map((location, index) => {
        const requiredFrom =
          index === 0
            ? drop.totime || getMinimumToTimeForStop("drop")
            : current[index - 1]?.totime || "";
        const nextState = { ...location };
        if (
          requiredFrom &&
          (!nextState.fromtime ||
            compareTimeValues(nextState.fromtime, requiredFrom) === -1)
        ) {
          nextState.fromtime = requiredFrom;
          nextState.time = requiredFrom;
        }
        const minimumTo = getMinimumToTimeForStop(
          "droppoint",
          index,
          nextState.fromtime,
        );
        if (
          minimumTo &&
          (!nextState.totime ||
            compareTimeValues(nextState.totime, minimumTo) === -1)
        ) {
          nextState.totime = minimumTo;
        }
        return nextState;
      }),
    );
  }, [
    formState.delivery_type,
    currentTimeTick,
    pickup.date,
    pickup.fromtime,
    pickup.totime,
    drop.fromtime,
    drop.totime,
    droplocations
      .map(
        (location) => `${location?.fromtime || ""}|${location?.totime || ""}`,
      )
      .join("||"),
    scheduledSegmentMinutes,
  ]);

  useEffect(() => {
    if (
      formState.delivery_type !== "scheduled" ||
      !scheduledSegmentSignature ||
      !pickup.totime
    ) {
      return;
    }

    setDrop((current) => {
      const nextState = { ...current };
      let hasChanges = false;
      const requiredFrom = pickup.totime;
      const nextFromTime =
        requiredFrom &&
        (!nextState.fromtime ||
          compareTimeValues(nextState.fromtime, requiredFrom) === -1)
          ? requiredFrom
          : nextState.fromtime;

      if (nextFromTime !== nextState.fromtime) {
        nextState.fromtime = nextFromTime;
        nextState.time = nextFromTime;
        hasChanges = true;
      }

      const exactToTime = getMinimumToTimeForStop(
        "drop",
        null,
        nextState.fromtime,
      );
      if (exactToTime && exactToTime !== nextState.totime) {
        nextState.totime = exactToTime;
        hasChanges = true;
      }

      return hasChanges ? nextState : current;
    });

    setDroplocations((current) => {
      let previousToTime =
        drop.totime || getMinimumToTimeForStop("drop", null, pickup.totime);
      let hasChanges = false;

      const nextLocations = current.map((location, index) => {
        const nextState = { ...location };
        const requiredFrom = previousToTime || "";
        const nextFromTime =
          requiredFrom &&
          (!nextState.fromtime ||
            compareTimeValues(nextState.fromtime, requiredFrom) === -1)
            ? requiredFrom
            : nextState.fromtime;

        if (nextFromTime !== nextState.fromtime) {
          nextState.fromtime = nextFromTime;
          nextState.time = nextFromTime;
          hasChanges = true;
        }

        const exactToTime = getMinimumToTimeForStop(
          "droppoint",
          index,
          nextState.fromtime,
        );
        if (exactToTime && exactToTime !== nextState.totime) {
          nextState.totime = exactToTime;
          previousToTime = exactToTime;
          hasChanges = true;
        } else {
          previousToTime =
            nextState.totime || nextState.fromtime || previousToTime;
        }

        return nextState;
      });

      return hasChanges ? nextLocations : current;
    });
  }, [
    formState.delivery_type,
    pickup.totime,
    drop.totime,
    scheduledSegmentSignature,
  ]);

  const handleQuickPackageSelect = (packageType) => {
    setFormState((current) => ({
      ...current,
      package: packageType,
    }));

    if (formErrors.package) {
      setFormErrors((current) => ({
        ...current,
        package: null,
      }));
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!canAutoUpdateFare) {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      fetchDistanceAndCost();
    }, 600);

    return () => window.clearTimeout(timer);
  }, [
    canAutoUpdateFare,
    pickup.latitude,
    pickup.longitude,
    drop.latitude,
    drop.longitude,
    dropRouteSignature,
    formState.parcel_weight,
    formState.parcel_value,
    formState.delivery_type,
  ]);

  useEffect(() => {
    if (!hasPrimaryRoute || hasPendingDropPoints) {
      resetFareSummary();
    }
  }, [hasPrimaryRoute, hasPendingDropPoints]);

  useEffect(() => {
    const inputs = document.querySelectorAll("#orderForm input");
    inputs.forEach((input) => {
      input.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
        }
      });
    });
    return () => {
      // Cleanup event listeners if needed
    };
  }, []);

  useEffect(() => {
    if (
      localStorage.getItem("token") == "" ||
      localStorage.getItem("token") == undefined ||
      localStorage.getItem("token") == null
    ) {
      alert("Please Login to your account!");
      navigate("/");
    }
    let isActive = true;
    preloadPriceConfiguration()
      .then((configuration) => {
        if (isActive) {
          setPriceData(configuration);
        }
      })
      .catch((error) => {
        console.error("Error fetching price data:", error);
      });

    return () => {
      isActive = false;
    };
  }, [navigate]);

  useEffect(() => {
    if (bookingDraft) clearBookingDraft();
  }, [bookingDraft]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (token) {
          const response = await axios.get(`${API_URL}/user`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          const userData = response.data.user;
          setUserData(response.data.user);
          if (bookingDraft) {
            setPickup((current) => ({
              ...current,
              name: current.name || userData.fullname || "",
              phone_number:
                current.phone_number ||
                (userData.mobileno ? formatPhoneNumber(userData.mobileno) : ""),
            }));
          }
          if (userData.wallet < 0) {
            setWalletDue(Math.abs(userData.wallet));
            setHasWalletDue(true);
          }
          if (userData.mobileno) {
            setFormState((current) =>
              current.phone_number
                ? current
                : {
                    ...current,
                    phone_number: formatPhoneNumber(userData.mobileno),
                  },
            );
          }
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, [bookingDraft]);

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  const getGstDetailsPayload = () => {
    const defaultGstin = Array.isArray(userData?.gstins)
      ? userData.gstins.find((item) => item?.isDefault)
      : null;
    if (!defaultGstin) {
      return {
        includeGst: false,
        legalName: "",
        gstin: "",
      };
    }
    return {
      includeGst: true,
      legalName: defaultGstin.legalName || "",
      gstin: defaultGstin.gstin || "",
    };
  };

  const fetchDistanceAndCost = async () => {
    const pricingRequestId = ++pricingRequestIdRef.current;
    const isCurrentPricingRequest = () =>
      pricingRequestId === pricingRequestIdRef.current;

    if (!pickup.latitude || !drop.latitude) {
      resetFareSummary();
      return null;
    }

    if (hasPendingDropPoints) {
      resetFareSummary();
      return null;
    }

    if (!validateDifferentPickupAndDrop(pickup, drop, toast)) {
      resetFareSummary();
      return null;
    }

    if (!validateUniqueLocations([pickup, drop, ...droplocations])) {
      resetFareSummary();
      return null;
    }

    const parcelValue = Number(formState.parcel_value);
    const hasParcelValue =
      Number.isFinite(parcelValue) && parcelValue >= 1 && parcelValue <= 30000;
    if (Number.isFinite(parcelValue) && parcelValue > 30000) {
      resetFareSummary();
      return null;
    }
    // A parcel value is required only at checkout. Before that, obtain the
    // live route/heatmap fare with the minimum valid value and omit its
    // placeholder security fee from the displayed estimate.
    const quoteParcelValue = hasParcelValue ? parcelValue : 1;

    const token = localStorage.getItem("token");
    if (!token) {
      resetFareSummary();
      return null;
    }

    setIsCalculating(true);
    try {
      // One authoritative quote supplies both fare and delivery distances.
      const liveQuotePromise = axios
        .post(
          `${API_URL}/order/quote`,
          {
            locations: normalizeLocationsForPayload(
              [pickup, drop, ...droplocations],
              formState.delivery_type,
            ),
            parcel_weight: formState.parcel_weight,
            parcel_value: quoteParcelValue,
            delivery_type: formState.delivery_type,
            payment_method: payment,
            pointsUsed: 0,
          },
          { headers: { Authorization: `Bearer ${token}` } },
        )
        .then((response) => {
          const quote = response.data || {};
          if (quote.error || !Number.isFinite(Number(quote.amount))) {
            throw new Error(
              quote.message || "Unable to calculate the live delivery price.",
            );
          }
          const deliveryCharge = Number(quote.deliveryCharge) || 0;
          const flexibleDiscount =
            Number(quote.flexibleDeliveryDiscountAmount) || 0;
          const securityFee = hasParcelValue
            ? Number(quote.securityFee) || 0
            : 0;
          const total =
            (Number(quote.amount) || 0) -
            (Number(quote.securityFee) || 0) +
            securityFee;
          if (isCurrentPricingRequest()) {
            setOrderAmount(deliveryCharge + flexibleDiscount);
            setSecurityFeeAmount(securityFee);
            setFlexibleDeliveryDiscountAmount(flexibleDiscount);
            setAmount(total);
          }
          return response;
        });

      const quoteResponse = await liveQuotePromise;
      if (!isCurrentPricingRequest()) return null;
      const quote = quoteResponse.data || {};
      const distArr = quote.distances;
      if (
        !Array.isArray(distArr) ||
        distArr.length !== droplocations.length + 1 ||
        distArr.some((value) => !Number.isFinite(value) || value <= 0)
      ) {
        throw new Error("Unable to verify delivery distances.");
      }
      const mainDistance = distArr[0];
      try {
        const segmentMinutes =
          formState.delivery_type === "scheduled"
            ? await fetchScheduledOrderMinimumTimes(distArr)
            : [];
        if (isCurrentPricingRequest()) {
          setScheduledSegmentMinutes(segmentMinutes);
        }

        if (
          isCurrentPricingRequest() &&
          formState.delivery_type === "scheduled"
        ) {
          const syncedTimeState = buildScheduledRouteTimeState(segmentMinutes);
          if (syncedTimeState) {
            setPickup(syncedTimeState.pickup);
            setDrop(syncedTimeState.drop);
            setDroplocations(syncedTimeState.droplocations);
          }
        }
      } catch (error) {
        console.warn(
          "Optional website route timing calculation unavailable:",
          error,
        );
      }

      if (!isCurrentPricingRequest()) return null;
      const quoteDeliveryCharge = Number(quote.deliveryCharge) || 0;
      const quoteFlexibleDiscount =
        Number(quote.flexibleDeliveryDiscountAmount) || 0;
      const quoteSecurityFee = hasParcelValue
        ? Number(quote.securityFee) || 0
        : 0;
      const quoteTotal =
        (Number(quote.amount) || 0) -
        (Number(quote.securityFee) || 0) +
        quoteSecurityFee;
      const quoteOrderAmount = quoteDeliveryCharge + quoteFlexibleDiscount;
      setOrderAmount(quoteOrderAmount);
      setSecurityFeeAmount(quoteSecurityFee);
      setFlexibleDeliveryDiscountAmount(quoteFlexibleDiscount);
      setAmount(quoteTotal);
      return {
        distances: Array.isArray(quote.distances) ? quote.distances : distArr,
        mainDistance,
        fareAmount: quoteOrderAmount,
        deliveryCharge: quoteDeliveryCharge,
        baseAmount:
          (Number(quote.baseAmount) || 0) -
          (Number(quote.securityFee) || 0) +
          quoteSecurityFee,
        securityFee: quoteSecurityFee,
        securityFeePercent: Number(quote.securityFeePercent) || 0,
        flexibleDeliveryDiscountPercent:
          Number(quote.flexibleDeliveryDiscountPercent) || 0,
        flexibleDeliveryDiscountAmount: quoteFlexibleDiscount,
        heatmapPriceHikePercent: Number(quote.heatmapPriceHikePercent) || 0,
        heatmapPriceHikeAmount: Number(quote.heatmapPriceHikeAmount) || 0,
        commission: Number(priceData?.instaportCommission) || 0,
        walletDueAmount: Number(quote.walletDue) || 0,
        totalWithDue: quoteTotal,
      };
    } catch (error) {
      console.error("Error calculating price:", error);
      if (isCurrentPricingRequest()) {
        resetFareSummary();
      }
      return null;
    } finally {
      setIsCalculating(false);
    }
  };

  // Validate form function
  const validateForm = () => {
    const errors = {};
    const validateLocation = (location, prefix, label, index = null) => {
      const getFieldKey = (field) =>
        prefix === "droppoint"
          ? getDropPointErrorKey(field, index)
          : `${prefix}_${field}`;

      const phoneDigits = getPhoneDigits(location?.phone_number);
      const name = String(location?.name || "").trim();
      const hasCoordinates = Boolean(location?.latitude && location?.longitude);

      if (!hasCoordinates) {
        errors[getFieldKey("search")] =
          `Please select a valid ${label} address`;
      }

      if (!name) {
        errors[getFieldKey("name")] = "Please enter contact name";
      } else if (name.length < 2) {
        errors[getFieldKey("name")] = "Please enter a valid name";
      }

      if (!phoneDigits) {
        errors[getFieldKey("phone_number")] = "Please enter mobile number";
      } else if (!isValidPhoneNumber(location?.phone_number)) {
        errors[getFieldKey("phone_number")] =
          "Please enter a valid 10-digit mobile number";
      }

      if (formState.delivery_type === "scheduled") {
        if (prefix === "pickup") {
          if (!location?.date) {
            errors[getFieldKey("date")] = "Please select pickup date";
          } else if (
            location.date < pickupDateMin ||
            location.date > pickupDateMax
          ) {
            errors[getFieldKey("date")] =
              "Pickup date must be within the next 4 days including today";
          }
        }

        const hasFromTime = Boolean(location?.fromtime);
        const hasToTime = Boolean(location?.totime);
        const requiredFromTime =
          prefix === "pickup"
            ? ""
            : prefix === "drop"
              ? getRequiredFromTimeForStop("drop")
              : getRequiredFromTimeForStop("droppoint", index);
        const minimumToTime =
          prefix === "pickup"
            ? getMinimumToTimeForStop("pickup", null, location?.fromtime || "")
            : prefix === "drop"
              ? getMinimumToTimeForStop("drop", null, location?.fromtime || "")
              : getMinimumToTimeForStop(
                  "droppoint",
                  index,
                  location?.fromtime || "",
                );
        const minimumMinutes =
          prefix === "pickup"
            ? PICKUP_SCHEDULE_MINUTES
            : prefix === "drop"
              ? getSegmentMinimumMinutes(0)
              : getSegmentMinimumMinutes(index + 1);

        if (!hasFromTime) {
          errors[getFieldKey("fromtime")] = "Please select from time";
        }

        if (!hasToTime) {
          errors[getFieldKey("totime")] = "Please select to time";
        }

        if (
          hasFromTime &&
          requiredFromTime &&
          compareTimeValues(location?.fromtime, requiredFromTime) === -1
        ) {
          errors[getFieldKey("fromtime")] =
            prefix === "pickup"
              ? "Can't select time before current time"
              : prefix === "drop"
                ? "Can't select time before pickup time"
                : "Can't select time before previous drop time";
        }

        if (
          hasFromTime &&
          hasToTime &&
          compareTimeValues(location?.totime, location?.fromtime) !== 1
        ) {
          errors[getFieldKey("totime")] = "To time must be after from time";
        } else if (
          hasFromTime &&
          hasToTime &&
          minimumToTime &&
          compareTimeValues(location?.totime, minimumToTime) === -1
        ) {
          errors[getFieldKey("totime")] =
            getDropTimeErrorMessage(minimumMinutes);
        }
      }
    };

    validateLocation(pickup, "pickup", "pickup");
    validateLocation(drop, "drop", "drop");
    droplocations.forEach((location, index) => {
      validateLocation(location, "droppoint", `drop point ${index + 2}`, index);
    });

    if (!validateDifferentPickupAndDrop(pickup, drop)) {
      showDuplicateAddressFeedback();
      errors.location_match = "Pickup and drop location cannot be the same.";
    }

    if (!validateUniqueLocations([pickup, drop, ...droplocations])) {
      showDuplicateAddressFeedback();
      errors.location_match = "Same address cannot be used for multiple stops.";
    }

    if (!formState.phone_number) {
      errors.phone_number = "Please enter mobile number";
    } else if (!isValidPhoneNumber(formState.phone_number)) {
      errors.phone_number = "Please enter a valid 10-digit phone number";
    }

    if (!formState.package || formState.package.trim() === "") {
      errors.package = "Please specify what you're sending";
    }

    const parcelValue = Number(formState.parcel_value) || 0;
    if (parcelValue < 1 || parcelValue > 30000) {
      errors.parcel_value = "Parcel value must be between ₹1 and ₹30000";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validateScheduledTimeWindows = async () => {
    if (formState.delivery_type !== "scheduled") {
      return true;
    }

    const locationsToValidate = [
      { location: pickup, prefix: "pickup", index: null },
      { location: drop, prefix: "drop", index: null },
      ...droplocations.map((location, index) => ({
        location,
        prefix: "droppoint",
        index,
      })),
    ];

    const nextErrors = {};
    const getFieldKey = (prefix, field, index = null) =>
      prefix === "droppoint"
        ? getDropPointErrorKey(field, index)
        : `${prefix}_${field}`;

    for (const { location, prefix, index } of locationsToValidate) {
      const hasFromTime = Boolean(location?.fromtime);
      const hasToTime = Boolean(location?.totime);

      if (!hasFromTime || !hasToTime) {
        continue;
      }

      const requiredFromTime =
        prefix === "pickup"
          ? ""
          : prefix === "drop"
            ? getRequiredFromTimeForStop("drop")
            : getRequiredFromTimeForStop("droppoint", index);
      if (
        requiredFromTime &&
        compareTimeValues(location.fromtime, requiredFromTime) === -1
      ) {
        nextErrors[getFieldKey(prefix, "fromtime", index)] =
          prefix === "pickup"
            ? "Can't select time before current time"
            : prefix === "drop"
              ? "Can't select time before pickup time"
              : "Can't select time before previous drop time";
      }

      const minimumToTime =
        prefix === "pickup"
          ? getMinimumToTimeForStop("pickup", null, location.fromtime)
          : prefix === "drop"
            ? getMinimumToTimeForStop("drop", null, location.fromtime)
            : getMinimumToTimeForStop("droppoint", index, location.fromtime);
      const minimumMinutes =
        prefix === "pickup"
          ? PICKUP_SCHEDULE_MINUTES
          : prefix === "drop"
            ? getSegmentMinimumMinutes(0)
            : getSegmentMinimumMinutes(index + 1);

      if (!minimumToTime) {
        nextErrors[getFieldKey(prefix, "totime", index)] =
          "Selected from time leaves no valid time range in the same day";
        continue;
      }

      if (compareTimeValues(location.totime, minimumToTime) === -1) {
        nextErrors[getFieldKey(prefix, "totime", index)] =
          prefix === "pickup"
            ? "To time must be at least 30 minutes after from time"
            : getDropTimeErrorMessage(minimumMinutes);
      }
    }

    if (Object.keys(nextErrors).length > 0) {
      setFormErrors((current) => ({
        ...current,
        ...nextErrors,
      }));
      toast.error("Please correct the scheduled time windows.");
      return false;
    }

    return true;
  };

  const runPreSubmitScheduledValidation = async () => {
    const pricing = await fetchDistanceAndCost();
    if (!pricing) {
      toast.error("Unable to calculate fare for the selected route.");
      return false;
    }

    return validateScheduledTimeWindows();
  };

  // Handle pickup address selection with auto price calculation
  const handlePickupSelect = (selectedLocation) => {
    const nextPickup = applySelectedLocation(pickup, selectedLocation);
    if (!nextPickup) return false;

    if (hasDuplicateLocationSelection(nextPickup, "pickup")) {
      clearLocationSearch("pickup");
      showDuplicateAddressFeedback();
      return false;
    }

    setPickup(nextPickup);
    clearFieldErrors("pickup_search");
    return true;
  };

  // Handle drop address selection with auto price calculation
  const handleDropSelect = (selectedLocation) => {
    const nextDrop = applySelectedLocation(drop, selectedLocation);
    if (!nextDrop) return false;

    if (hasDuplicateLocationSelection(nextDrop, "drop")) {
      clearLocationSearch("drop");
      showDuplicateAddressFeedback();
      return false;
    }

    setDrop(nextDrop);
    clearFieldErrors("drop_search");
    return true;
  };

  // Handle weight change with auto price calculation
  const handleWeightChange = (selectedWeight) => {
    setFormState({
      ...formState,
      parcel_weight: selectedWeight,
    });
  };

  const handlePayment = async () => {
    // Prevent multiple clicks
    if (isPlacingOrder || orderPlacementLockRef.current) {
      return;
    }

    if (isCalculating) {
      toast.info("Please wait while we calculate the fare.");
      return;
    }

    const cancelOrderPlacement = () => {
      orderPlacementLockRef.current = false;
      setIsPlacingOrder(false);
    };

    // Lock synchronously so a second click cannot start another checkout while
    // React is scheduling the loading state update.
    orderPlacementLockRef.current = true;
    setIsPlacingOrder(true);

    if (formState.delivery_type === "flexible" && !isFlexibleBookingOpen()) {
      toast.info(FLEXIBLE_DELIVERY_UNAVAILABLE_MESSAGE);
      cancelOrderPlacement();
      return;
    }

    if (!validateForm()) {
      toast.error("Please fix the form errors before proceeding");
      cancelOrderPlacement();
      return;
    }

    if (!validateDifferentPickupAndDrop(pickup, drop, toast)) {
      cancelOrderPlacement();
      return;
    }

    // Add validation for payment address when COD is selected
    if (payment === "cod" && (!paymentAddress || !paymentAddress.key)) {
      toast.error("Please select a payment collection address for COD");
      cancelOrderPlacement();
      return;
    }

    if (
      localStorage.getItem("token") == "" ||
      localStorage.getItem("token") == undefined ||
      localStorage.getItem("token") == null
    ) {
      alert("Please Login to your account!");
      cancelOrderPlacement();
      return;
    }

    const scheduleWindowValid = await runPreSubmitScheduledValidation();
    if (!scheduleWindowValid) {
      cancelOrderPlacement();
      return;
    }

    let pricing = await fetchDistanceAndCost();
    if (!pricing || pricing.totalWithDue === 0) {
      toast.error("Please enter valid addresses to calculate fare first");
      cancelOrderPlacement();
      return;
    }

    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    const timestamp = new Date().getTime();
    const locations = normalizeLocationsForPayload(
      [pickup, drop, ...droplocations],
      formState.delivery_type,
    );
    try {
      const quoteResponse = await axios.post(
        `${API_URL}/order/quote`,
        {
          locations,
          parcel_weight: formState.parcel_weight,
          parcel_value: Number(formState.parcel_value) || 0,
          delivery_type: formState.delivery_type,
          payment_method: payment,
          pointsUsed: 0,
        },
        { headers },
      );
      const quote = quoteResponse.data || {};
      if (quote.error || !Number.isFinite(Number(quote.amount))) {
        throw new Error(
          quote.message || "Unable to verify the delivery price.",
        );
      }
      pricing = {
        ...pricing,
        baseAmount: Number(quote.baseAmount) || 0,
        totalWithDue: Number(quote.amount) || 0,
        deliveryCharge: Number(quote.deliveryCharge) || 0,
        securityFee: Number(quote.securityFee) || 0,
        securityFeePercent: Number(quote.securityFeePercent) || 0,
        walletDueAmount: Number(quote.walletDue) || 0,
        heatmapPriceHikePercent: Number(quote.heatmapPriceHikePercent) || 0,
        heatmapPriceHikeAmount: Number(quote.heatmapPriceHikeAmount) || 0,
        pricingQuote: String(quote.pricingQuote || ""),
      };
      setAmount(pricing.totalWithDue);
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Unable to verify the delivery price.",
      );
      cancelOrderPlacement();
      return;
    }
    const syncedPaymentAddress =
      payment === "cod"
        ? locations.find((location) => location.key === paymentAddress?.key) ||
          locations[1] ||
          locations[0] ||
          null
        : null;
    const gstDetailsPayload = getGstDetailsPayload();
    const commonPayload = {
      ...formState,
      locations,
      amount: pricing.baseAmount,
      base_amount: pricing.baseAmount,
      payment_method: payment,
      status: "new",
      wallet_due: pricing.walletDueAmount,
      wallet_due_paid: payment !== "cod",
      pointsUsed: 0,
      droplocations,
      commission: pricing.commission,
      payment_address: syncedPaymentAddress,
      distances: pricing.distances,
      time_stamp: timestamp,
      timer: 0,
      parcel_value: Number(formState.parcel_value) || 0,
      security_fee: pricing.securityFee,
      security_fee_percent: pricing.securityFeePercent,
      delivery_charge: pricing.deliveryCharge,
      flexible_delivery_discount_percent:
        pricing.flexibleDeliveryDiscountPercent,
      flexible_delivery_discount_amount: pricing.flexibleDeliveryDiscountAmount,
      gstDetails: gstDetailsPayload,
      order_source: "website",
      couponCode: "",
      discountCoupon: null,
      discount: 0,
      pricingQuote: pricing.pricingQuote,
    };

    if (payment === "cod") {
      axios(`${API_URL}/order/create`, {
        method: "POST",
        data: {
          ...commonPayload,
          amount: pricing.totalWithDue,
          payment_method: "cod",
        },
        headers,
      })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data);
            toast.error("Order creation failed");
            setIsPlacingOrder(false);
          } else {
            set(ref(db, "orders/" + res.data.order._id), res.data.order);
            toast.success(res.data.message);
            dispatchWebsiteNotification({
              eventKey: `order:${res.data.order._id}:created`,
              title: "Order Created",
              body: `Your order #${res.data.order.orderId || res.data.order._id} has been created successfully.`,
              tag: `created-${res.data.order._id}`,
            });
            setShow(false);
            setIsPlacingOrder(false);

            // Redirect to orders page after successful order creation
            setTimeout(() => {
              navigate("/orders");
            }, 1500);
          }
        })
        .catch((err) => {
          console.error(err);
          toast.error("Something went wrong with order creation");
          setIsPlacingOrder(false);
        });
    } else if (payment === "wallet") {
      axios(`${API_URL}/customer-transactions/wallet-order-payment`, {
        method: "POST",
        data: {
          ...commonPayload,
          amount: pricing.baseAmount,
          payment_method: "wallet",
        },
        headers,
      })
        .then((res) => {
          if (res.data.error) {
            toast.error(res.data.message || "Wallet payment failed");
            setIsPlacingOrder(false);
          } else {
            if (res.data.order?._id) {
              set(ref(db, "orders/" + res.data.order._id), res.data.order);
            }
            toast.success(res.data.message || "Order created successfully");
            if (res.data.order?._id) {
              dispatchWebsiteNotification({
                eventKey: `payment:${res.data.order._id}:wallet-success`,
                title: "Payment Successful",
                body: `Wallet payment was successful for order #${res.data.order.orderId || res.data.order._id}.`,
                tag: `wallet-payment-${res.data.order._id}`,
              });
              dispatchWebsiteNotification({
                eventKey: `order:${res.data.order._id}:created`,
                title: "Order Created",
                body: `Your order #${res.data.order.orderId || res.data.order._id} has been created successfully.`,
                tag: `created-${res.data.order._id}`,
              });
            }
            setShow(false);
            setIsPlacingOrder(false);
            setTimeout(() => {
              navigate("/orders");
            }, 1500);
          }
        })
        .catch((err) => {
          console.error(err);
          toast.error(err?.response?.data?.message || "Wallet payment failed");
          setIsPlacingOrder(false);
        });
    } else if (payment === "online") {
      const paymentApiUrl = String(API_URL);
      try {
        const res = await loadScript(
          "https://checkout.razorpay.com/v1/checkout.js",
        );
        if (!res) {
          alert("Failed to load Razorpay SDK");
          setIsPlacingOrder(false);
          return;
        }

        const orderRes = await axios({
          url: `${paymentApiUrl}/razorpay/create-order`,
          method: "POST",
          data: {
            amount: pricing.totalWithDue,
            currency: "INR",
            receipt: "order_" + timestamp,
            source: "website",
            purpose: "order_payment",
            pricingQuote: pricing.pricingQuote,
            orderDraft: { ...commonPayload, payment_method: "online" },
          },
          headers,
        });

        const checkout = checkoutOrderSettings(orderRes.data);
        let paymentCompleted = false;
        const options = {
          ...checkout,
          name: "Instaport Delivery",
          description: "Order Payment",
          image: "https://instaportdelivery.com/assets/logo/logo.png",
          handler: async function (response) {
            if (paymentCompleted) return;
            paymentCompleted = true;

            try {
              const orderCreateRes = await completeOnlineOrder({
                apiUrl: paymentApiUrl,
                headers,
                payment: response,
                checkout: orderRes.data,
              });

              if (orderCreateRes.data.error) {
                console.log(orderCreateRes.data);
                toast.error("Order creation failed");
                setIsPlacingOrder(false);
              } else {
                set(
                  ref(db, "orders/" + orderCreateRes.data.order._id),
                  orderCreateRes.data.order,
                ).catch((error) =>
                  console.error("Order mirror update failed:", error),
                );
                await axios({
                  url: `${paymentApiUrl}/customer-transactions/manual-log`,
                  method: "POST",
                  data: {
                    orderId: orderCreateRes.data.order._id,
                    type: "online",
                    transactionId: response.razorpay_payment_id,
                    amount: pricing.baseAmount,
                    time_stamp: timestamp,
                  },
                  headers,
                }).catch(() =>
                  toast.warning(
                    "Your order is confirmed, but its receipt could not be loaded. Please contact support.",
                  ),
                );
                toast.success(orderCreateRes.data.message);
                dispatchWebsiteNotification({
                  eventKey: `payment:${orderCreateRes.data.order._id}:online-success`,
                  title: "Payment Successful",
                  body: `Online payment was successful for order #${orderCreateRes.data.order.orderId || orderCreateRes.data.order._id}.`,
                  tag: `online-payment-${orderCreateRes.data.order._id}`,
                });
                dispatchWebsiteNotification({
                  eventKey: `order:${orderCreateRes.data.order._id}:created`,
                  title: "Order Created",
                  body: `Your order #${orderCreateRes.data.order.orderId || orderCreateRes.data.order._id} has been created successfully.`,
                  tag: `created-${orderCreateRes.data.order._id}`,
                });
                setShow(false);
                setIsPlacingOrder(false);

                // Redirect to orders page after successful order creation
                setTimeout(() => {
                  navigate("/orders");
                }, 1500);
              }
            } catch (error) {
              console.error("Online order creation failed:", error);
              toast.error(
                error?.response?.data?.message ||
                  error?.message ||
                  "Payment was successful, but the order could not be created.",
              );
              setIsPlacingOrder(false);
            }
          },
          prefill: {
            name: pickup.name || "",
            contact: getPhoneInputValue(formState.phone_number).replace(
              /\D/g,
              "",
            ),
          },
          notes: {
            address: "Instaport Corporate Office",
          },
          theme: {
            color: "#69068a",
          },
          modal: {
            ondismiss: () => {
              if (!paymentCompleted) {
                setIsPlacingOrder(false);
              }
            },
          },
        };

        const rzp1 = new window.Razorpay(options);
        rzp1.on("payment.failed", () => {
          setIsPlacingOrder(false);
        });
        rzp1.open();
      } catch (error) {
        console.error("Unable to start online payment:", error);
        toast.error(
          error?.response?.data?.message ||
            "Unable to start online payment. Please try again.",
        );
        setIsPlacingOrder(false);
      }
    }
  };

  const handleChange = (e) => {
    const nextValue =
      e.target.id === "parcel_value"
        ? e.target.value === ""
          ? ""
          : String(
              Math.min(
                30000,
                Math.max(1, Math.round(Number(e.target.value) || 0)),
              ),
            )
        : e.target.value;

    setFormState({
      ...formState,
      [e.target.id]: nextValue,
    });

    // Clear error for this field if it exists
    if (formErrors[e.target.id]) {
      clearFieldErrors(e.target.id);
    }
  };

  const handleAddDeliveryPoint = () => {
    let arr = [...droplocations];
    arr.push({
      ...addressInitialState,
      key: uuidv4(),
      date:
        formState.delivery_type === "scheduled"
          ? pickup.date || pickupDateMin
          : "",
    });
    setDroplocations(arr);
  };

  const handleRemove = (dropIndex) => {
    let confirm = window.confirm(
      "Are you sure you want to delete the drop point?",
    );
    if (confirm) {
      let data = droplocations.filter((value, index) => {
        return index != dropIndex;
      });
      setDroplocations(data);
    }
  };

  // Handle additional drop location changes
  const handleDropLocationChange = (index, field, value) => {
    setDroplocations((current) =>
      current.map((location, locationIndex) =>
        locationIndex === index ? { ...location, [field]: value } : location,
      ),
    );

    if (
      field === "phone_number" ||
      field === "name" ||
      field === "fromtime" ||
      field === "totime"
    ) {
      clearFieldErrors(getDropPointErrorKey(field, index));
    }
  };

  const handleDropLocationSelect = (index, selectedLocation) => {
    const nextDropLocation = applySelectedLocation(
      droplocations[index],
      selectedLocation,
    );
    if (!nextDropLocation) return false;

    if (hasDuplicateLocationSelection(nextDropLocation, "droppoint", index)) {
      clearLocationSearch("droppoint", index);
      showDuplicateAddressFeedback();
      return false;
    }

    setDroplocations((current) =>
      current.map((droplocation, locationIndex) => {
        if (locationIndex !== index) {
          return droplocation;
        }

        return nextDropLocation;
      }),
    );
    clearFieldErrors(getDropPointErrorKey("search", index));
    return true;
  };

  return (
    <>
      <ServiceabilityModal
        open={showServiceabilityModal}
        onClose={() => setShowServiceabilityModal(false)}
      />
      <section
        id="main"
        className="h-auto w-screen Poppins flex flex-col bg-[#fafae0] relative"
      >
        <Navbar />

        {/* Fixed Price Display - Bottom Left Corner */}
        <div
          className={`hidden md:block fixed bottom-6 left-6 z-50 bg-white border-2 border-accentYellow rounded-xl shadow-lg p-4 w-64 lg:w-80 transform transition-all duration-300 ${
            hasFareSummary
              ? "translate-y-0 opacity-100"
              : "translate-y-full opacity-0"
          }`}
        >
          <div className="flex items-center justify-between mb-2">
            <h3 className="font-bold text-lg text-gray-800">Estimated Fare</h3>
            <div className="text-2xl font-bold text-accentYellow">
              {fareDisplayLabel}
            </div>
            {/* {isCalculating && (
      <div className="flex items-center gap-1">
        <div className="w-4 h-4 border-2 border-gray-300 border-t-accentYellow rounded-full animate-spin"></div>
        <span className="text-sm text-gray-500">Calculating...</span>
      </div>
    )} */}
          </div>
          <div className="text-sm text-gray-600 space-y-1">
            <div className="mt-2 pt-2 border-t border-gray-200">
              {/* Always show Order Amount */}
              <div className="flex justify-between items-center">
                <div
                  className="flex items-center cursor-pointer"
                  onClick={() => setShowWalletDueInfo(!showWalletDueInfo)}
                >
                  <span className="text-sm font-medium text-gray-800">
                    Order Amount
                  </span>
                </div>
                <span className="text-sm font-semibold text-gray-800">
                  ₹{orderAmount.toFixed(0)}
                </span>
              </div>
              {flexibleDeliveryDiscountAmount > 0 && (
                <div className="flex justify-between items-center mt-1">
                  <span className="text-sm font-medium text-green-600">
                    Flexible delivery discount ({flexibleDiscountPercent}%)
                  </span>
                  <span className="text-sm font-semibold text-green-600">
                    - ₹{flexibleDeliveryDiscountAmount.toFixed(0)}
                  </span>
                </div>
              )}
              {securityFeeAmount > 0 && (
                <div className="flex justify-between items-center mt-1">
                  <div className="flex items-center gap-1">
                    <span className="text-sm font-medium text-gray-800">
                      Security Fee
                    </span>
                    <SecurityFeeInfoButton iconClassName="text-gray-500 text-xs" />
                  </div>
                  <span className="text-sm font-semibold text-gray-800">
                    ₹{securityFeeAmount.toFixed(0)}
                  </span>
                </div>
              )}

              {/* Show Wallet Due only if it exists */}
              {hasWalletDue && (
                <div className="flex justify-between items-center mt-1">
                  <div
                    className="flex items-center cursor-pointer"
                    onClick={() => setShowWalletDueInfo(!showWalletDueInfo)}
                  >
                    <span className="text-sm font-medium text-red-600">
                      Wallet Due
                    </span>
                    <FiInfo className="ml-1 text-red-500 text-xs" />
                  </div>
                  <span className="text-sm font-semibold text-red-600">
                    ₹{walletDue.toFixed(0)}
                  </span>
                </div>
              )}

              {showWalletDueInfo && (
                <div className="mt-1 text-xs text-gray-500 bg-red-50 p-2 rounded">
                  This amount represents your negative wallet balance from
                  previous orders. It will be added to your current order total.
                </div>
              )}
            </div>

            <p>
              <span className="font-medium">Weight:</span>{" "}
              {formState.parcel_weight}
            </p>
            {pickup.latitude && drop.latitude && (
              <>
                <p>
                  <span className="font-medium">Pickup:</span>{" "}
                  {pickup.address
                    ? pickup.address.substring(0, 30) + "..."
                    : "Not selected"}
                </p>
                <p>
                  <span className="font-medium">Drop:</span>{" "}
                  {drop.address
                    ? drop.address.substring(0, 30) + "..."
                    : "Not selected"}
                </p>
              </>
            )}
            {droplocations.length > 0 && (
              <p className="text-xs">
                +{droplocations.length} additional stops
              </p>
            )}
          </div>
          {/* <button
    onClick={fetchDistanceAndCost}
    disabled={isCalculating || !pickup.latitude || !drop.latitude}
    className={`mt-3 w-full py-2 rounded-lg font-medium transition-all duration-200 ${
      isCalculating || !pickup.latitude || !drop.latitude
        ? "bg-gray-200 text-gray-400 cursor-not-allowed"
        : "bg-accentYellow text-white hover:bg-accentYellow/90"
    }`}
  >
    {isCalculating ? "Calculating..." : "Recalculate Fare"}
  </button> */}
        </div>

        {/* Mobile Price Display - Fixed to bottom */}
        <div
          className={`lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-accentYellow shadow-lg p-3 transform transition-all duration-300 ${
            hasFareSummary ? "translate-y-0" : "translate-y-full"
          }`}
        >
          <div
            className="flex items-center justify-between cursor-pointer"
            onClick={() => setShowPriceDetails(!showPriceDetails)}
          >
            <div className="flex items-center">
              <div className="text-lg font-bold text-accentYellow mr-2">
                {fareDisplayLabel}
              </div>
              {/* {isCalculating && (
                <div className="w-4 h-4 border-2 border-gray-300 border-t-accentYellow rounded-full animate-spin"></div>
              )} */}
            </div>
            <div className="text-sm text-gray-600">
              {showPriceDetails ? "Hide details" : "Show details"}
            </div>
          </div>

          {showPriceDetails && (
            <div className="mt-3 pt-3 border-t border-gray-200">
              <div className="text-sm text-gray-600 space-y-1">
                <div className="mt-2 pt-2 border-t border-gray-200">
                  {/* Always show Order Amount */}
                  <div className="flex justify-between items-center">
                    <div
                      className="flex items-center cursor-pointer"
                      onClick={() => setShowWalletDueInfo(!showWalletDueInfo)}
                    >
                      <span className="text-sm font-medium text-gray-800">
                        Order Amount
                      </span>
                    </div>
                    <span className="text-sm font-semibold text-gray-800">
                      ₹{orderAmount.toFixed(0)}
                    </span>
                  </div>
                  {flexibleDeliveryDiscountAmount > 0 && (
                    <div className="flex justify-between items-center mt-1">
                      <span className="text-sm font-medium text-green-600">
                        Flexible delivery discount ({flexibleDiscountPercent}%)
                      </span>
                      <span className="text-sm font-semibold text-green-600">
                        - ₹{flexibleDeliveryDiscountAmount.toFixed(0)}
                      </span>
                    </div>
                  )}
                  {securityFeeAmount > 0 && (
                    <div className="flex justify-between items-center mt-1">
                      <div className="flex items-center gap-1">
                        <span className="text-sm font-medium text-gray-800">
                          Security Fee
                        </span>
                        <SecurityFeeInfoButton iconClassName="text-gray-500 text-xs" />
                      </div>
                      <span className="text-sm font-semibold text-gray-800">
                        ₹{securityFeeAmount.toFixed(0)}
                      </span>
                    </div>
                  )}

                  {/* Show Wallet Due only if it exists */}
                  {hasWalletDue && (
                    <div className="flex justify-between items-center mt-1">
                      <div
                        className="flex items-center cursor-pointer"
                        onClick={() => setShowWalletDueInfo(!showWalletDueInfo)}
                      >
                        <span className="text-sm font-medium text-red-600">
                          Wallet Due
                        </span>
                        <FiInfo className="ml-1 text-red-500 text-xs" />
                      </div>
                      <span className="text-sm font-semibold text-red-600">
                        ₹{walletDue.toFixed(0)}
                      </span>
                    </div>
                  )}

                  {showWalletDueInfo && (
                    <div className="mt-1 text-xs text-gray-500 bg-red-50 p-2 rounded">
                      This amount represents your negative wallet balance from
                      previous orders. It will be added to your current order
                      total.
                    </div>
                  )}
                </div>

                <p>
                  <span className="font-medium">Weight:</span>{" "}
                  {formState.parcel_weight}
                </p>
                {pickup.latitude && drop.latitude && (
                  <>
                    <p>
                      <span className="font-medium">Pickup:</span>{" "}
                      {pickup.address
                        ? pickup.address.substring(0, 20) + "..."
                        : "Not selected"}
                    </p>
                    <p>
                      <span className="font-medium">Drop:</span>{" "}
                      {drop.address
                        ? drop.address.substring(0, 20) + "..."
                        : "Not selected"}
                    </p>
                  </>
                )}
                {droplocations.length > 0 && (
                  <p className="text-xs">
                    +{droplocations.length} additional stops
                  </p>
                )}
              </div>
              {/* <button
                onClick={fetchDistanceAndCost}
                disabled={isCalculating || !pickup.latitude || !drop.latitude}
                className={`mt-3 w-full py-2 rounded-lg font-medium transition-all duration-200 ${
                  isCalculating || !pickup.latitude || !drop.latitude
                    ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                    : 'bg-accentYellow text-white hover:bg-accentYellow/90'
                }`}
              >
                {isCalculating ? 'Calculating...' : 'Recalculate Fare'}
              </button> */}
            </div>
          )}
        </div>

        <form
          id="orderForm"
          onSubmit={(e) => {
            e.preventDefault();
            if (isPreparingOrder || orderPreparationLockRef.current) {
              return;
            }

            (async () => {
              orderPreparationLockRef.current = true;
              setIsPreparingOrder(true);

              try {
                if (isCalculating) {
                  toast.info("Please wait while we calculate the fare.");
                  return;
                }

                if (
                  formState.delivery_type === "flexible" &&
                  !isFlexibleBookingOpen()
                ) {
                  toast.info(FLEXIBLE_DELIVERY_UNAVAILABLE_MESSAGE);
                  return;
                }

                if (!validateForm()) {
                  toast.error("Please fill all required fields correctly");
                  return;
                }

                const scheduleWindowValid =
                  await runPreSubmitScheduledValidation();
                if (!scheduleWindowValid) {
                  return;
                }

                if (amount === 0) {
                  toast.error(
                    "Please enter valid addresses to calculate fare first",
                  );
                  return;
                }

                setShow(true);
              } finally {
                orderPreparationLockRef.current = false;
                setIsPreparingOrder(false);
              }
            })();
          }}
          className="relative w-full px-3 pb-24 pt-[68px] sm:px-4 sm:pt-[76px] lg:px-6"
        >
          <div className="mx-auto w-full max-w-none space-y-5">
            <section className="relative overflow-hidden rounded-[30px] border border-[#f3e3b2] bg-[linear-gradient(180deg,#fffdf7_0%,#fff9ed_100%)] px-6 py-7 shadow-[0_18px_70px_rgba(196,151,69,0.14)] sm:px-8 lg:px-12 lg:py-8">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_15%_18%,rgba(255,227,138,0.30),rgba(255,255,255,0)_24%),radial-gradient(circle_at_86%_18%,rgba(255,205,77,0.16),rgba(255,255,255,0)_18%),linear-gradient(90deg,rgba(255,250,239,0.98)_0%,rgba(255,248,232,0.92)_44%,rgba(255,248,235,0.55)_72%,rgba(255,248,235,0.18)_100%)]" />
              <div className="absolute right-[7%] top-[18%] hidden text-[#efb317] lg:block">
                <FiMapPin size={26} />
              </div>
              <div className="relative grid items-center gap-8 lg:grid-cols-[minmax(0,1.02fr)_minmax(540px,0.98fr)]">
                <div className="max-w-[620px] py-4 text-left">
                  <h1 className="text-4xl font-black tracking-[-0.05em] text-[#0f172a] sm:text-5xl lg:text-[64px] lg:leading-[1.02]">
                    Create an Order
                  </h1>
                  <p className="mt-4 max-w-[540px] text-lg leading-9 text-[#465467] sm:text-[22px]">
                    Book your deliveries in just a few steps. Fast, reliable and
                    secure.
                  </p>
                  <div className="mt-4 flex items-center gap-3 text-[#efb317]">
                    <FiMapPin size={24} />
                    <span className="text-sm font-semibold uppercase tracking-[0.22em] text-[#d7a313]">
                      Pickup to delivery
                    </span>
                  </div>
                </div>
                <div className="relative min-h-[318px] overflow-hidden lg:min-h-[336px]">
                  <div className="absolute inset-y-0 right-0 w-[100%] bg-[radial-gradient(circle_at_68%_50%,rgba(255,214,103,0.92)_0%,rgba(255,226,142,0.52)_24%,rgba(255,244,221,0.16)_56%,rgba(255,248,235,0)_78%)]" />
                  <div className="absolute inset-y-0 left-0 w-[46%] bg-[linear-gradient(90deg,#fff9ed_0%,rgba(255,249,237,0.96)_36%,rgba(255,249,237,0.28)_74%,rgba(255,249,237,0)_100%)]" />
                  <div
                    className="absolute inset-y-0 right-0 h-full w-[102%] bg-contain bg-right-bottom bg-no-repeat"
                    style={{
                      backgroundImage:
                        "url('/assets/delivery_man_images/create_order_1.png')",
                      WebkitMaskImage:
                        "linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.28) 10%, rgba(0,0,0,0.9) 24%, rgba(0,0,0,1) 36%, rgba(0,0,0,1) 93%, rgba(0,0,0,0.76) 97%, rgba(0,0,0,0) 100%), linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.82) 14%, rgba(0,0,0,1) 26%, rgba(0,0,0,1) 84%, rgba(0,0,0,0.74) 94%, rgba(0,0,0,0) 100%), radial-gradient(circle at 72% 56%, rgba(0,0,0,1) 0%, rgba(0,0,0,0.95) 30%, rgba(0,0,0,0.75) 52%, rgba(0,0,0,0.22) 74%, rgba(0,0,0,0) 90%)",
                      maskImage:
                        "linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.28) 10%, rgba(0,0,0,0.9) 24%, rgba(0,0,0,1) 36%, rgba(0,0,0,1) 93%, rgba(0,0,0,0.76) 97%, rgba(0,0,0,0) 100%), linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.82) 14%, rgba(0,0,0,1) 26%, rgba(0,0,0,1) 84%, rgba(0,0,0,0.74) 94%, rgba(0,0,0,0) 100%), radial-gradient(circle at 72% 56%, rgba(0,0,0,1) 0%, rgba(0,0,0,0.95) 30%, rgba(0,0,0,0.75) 52%, rgba(0,0,0,0.22) 74%, rgba(0,0,0,0) 90%)",
                      WebkitMaskComposite: "source-in",
                      maskComposite: "intersect",
                    }}
                  />
                  <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(90deg,#fff9ed_0%,rgba(255,249,237,0)_18%,rgba(255,249,237,0)_82%,#fff9ed_100%),linear-gradient(180deg,#fff9ed_0%,rgba(255,249,237,0)_16%,rgba(255,249,237,0)_84%,#fff9ed_100%)]" />
                </div>
              </div>
            </section>

            {/* first box */}
            <div className="space-y-4">
              <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3 xl:items-start">
                <div
                  onClick={() => {
                    handleDeliveryTypeChange("now");
                  }}
                  className={
                    formState?.delivery_type === "now"
                      ? "flex min-h-[246px] w-full flex-col justify-between rounded-[24px] border border-[#efb317] bg-[linear-gradient(180deg,#fff9e7_0%,#fff2c9_100%)] px-6 py-6 text-left shadow-[0_16px_40px_rgba(15,23,42,0.08)] cursor-pointer"
                      : "flex min-h-[246px] w-full flex-col justify-between rounded-[24px] border border-[#edf0ea] bg-white px-6 py-6 text-left shadow-[0_16px_40px_rgba(15,23,42,0.08)] cursor-pointer hover:border-[#efcf7a]"
                  }
                >
                  <div className="text-2xl text-[#f3a700]">
                    <FiZap />
                  </div>
                  <div className="flex-1 pt-4">
                    <div className="text-[32px] font-bold tracking-[-0.03em] leading-tight text-[#111827]">
                      Deliver Now
                    </div>
                    <div className="mt-1 text-[18px] font-semibold text-[#111827]">
                      from {"\u20B9"}
                      {priceData?.base_order_charges || 0}
                    </div>
                    <div className="mt-3 text-[17px] leading-8 text-gray-500">
                      Our nearest courier will pick up and deliver as soon as
                      possible.
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-2 pt-4">
                    {DELIVERY_TYPE_FEATURES.now.map((item) => (
                      <span
                        key={item}
                        className="rounded-full border border-[#efcf7a] bg-white/70 px-3 py-1.5 text-sm font-semibold text-[#6b7280]"
                      >
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
                <div
                  onClick={() => {
                    if (!isFlexibleBookingOpen()) {
                      toast.info(FLEXIBLE_DELIVERY_UNAVAILABLE_MESSAGE);
                      return;
                    }
                    handleDeliveryTypeChange("flexible");
                  }}
                  className={
                    !flexibleDeliveryAvailable
                      ? "flex min-h-[246px] w-full cursor-not-allowed flex-col justify-between rounded-[24px] border border-[#edf0ea] bg-white px-6 py-6 text-left opacity-45 shadow-[0_16px_40px_rgba(15,23,42,0.08)]"
                      : formState?.delivery_type === "flexible"
                        ? "flex min-h-[246px] w-full flex-col justify-between rounded-[24px] border border-[#efb317] bg-[linear-gradient(180deg,#fff9e7_0%,#fff2c9_100%)] px-6 py-6 text-left shadow-[0_16px_40px_rgba(15,23,42,0.08)] cursor-pointer"
                        : "flex min-h-[246px] w-full flex-col justify-between rounded-[24px] border border-[#edf0ea] bg-white px-6 py-6 text-left shadow-[0_16px_40px_rgba(15,23,42,0.08)] cursor-pointer hover:border-[#efcf7a]"
                  }
                >
                  <div className="text-2xl text-[#f3a700]">
                    <LuClock3 />
                  </div>
                  <div className="flex-1 pt-4">
                    <div className="flex items-start justify-between gap-3">
                      <div className="text-[32px] font-bold tracking-[-0.03em] leading-tight text-[#111827]">
                        Flexible Delivery
                      </div>
                      <span className="shrink-0 text-[24px] font-extrabold leading-tight text-[#16803c]">
                        {flexibleDiscountLabel}
                      </span>
                    </div>
                    <div className="mt-1 text-[18px] font-semibold text-[#111827]">
                      from {"\u20B9"}
                      {priceData?.base_order_charges || 0}
                    </div>
                    <div className="mt-3 text-[17px] leading-8 text-gray-500">
                      Pickup starts in around 2.5 hours with same-day delivery
                      in 4-5 hours.
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-2 pt-4">
                    {DELIVERY_TYPE_FEATURES.flexible.map((item) => (
                      <span
                        key={item}
                        className="rounded-full border border-[#dfe4db] bg-[#f8faf7] px-3 py-1.5 text-sm font-semibold text-[#6b7280]"
                      >
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
                <div
                  onClick={() => {
                    handleDeliveryTypeChange("scheduled");
                  }}
                  className={
                    formState?.delivery_type === "scheduled"
                      ? "flex min-h-[246px] w-full flex-col justify-between rounded-[24px] border border-[#efb317] bg-[linear-gradient(180deg,#fff9e7_0%,#fff2c9_100%)] px-6 py-6 text-left shadow-[0_16px_40px_rgba(15,23,42,0.08)] cursor-pointer"
                      : "flex min-h-[246px] w-full flex-col justify-between rounded-[24px] border border-[#edf0ea] bg-white px-6 py-6 text-left shadow-[0_16px_40px_rgba(15,23,42,0.08)] cursor-pointer hover:border-[#efcf7a]"
                  }
                >
                  <div className="text-2xl text-[#f3a700]">
                    <FiCalendar />
                  </div>
                  <div className="flex-1 pt-4">
                    <div className="text-[32px] font-bold tracking-[-0.03em] leading-tight text-[#111827]">
                      Schedule
                    </div>
                    <div className="mt-1 text-[18px] font-semibold text-[#111827]">
                      from {"\u20B9"}
                      {priceData?.base_order_charges || 0}
                    </div>
                    <div className="mt-3 text-[17px] leading-8 text-gray-500">
                      Choose a convenient time for pickup and delivery
                      scheduling.
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-2 pt-4">
                    {DELIVERY_TYPE_FEATURES.scheduled.map((item) => (
                      <span
                        key={item}
                        className="rounded-full border border-[#dfe4db] bg-[#f8faf7] px-3 py-1.5 text-sm font-semibold text-[#6b7280]"
                      >
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              {/* second box - Weight Selection */}
              <div className="rounded-[24px] border border-[#edf0ea] bg-white px-5 py-5 shadow-[0_16px_40px_rgba(15,23,42,0.08)]">
                <h1 className="text-[28px] font-bold tracking-[-0.03em] text-[#111827]">
                  Weight of parcel
                </h1>
                <div className="mt-5 overflow-x-auto">
                  <div className="flex w-full min-w-max gap-3 pb-1">
                    {weight.map((w, index) => (
                      <button
                        key={index}
                        type="button"
                        onClick={() => handleWeightChange(w)}
                        className={
                          formState?.parcel_weight === w
                            ? "min-w-[150px] flex-1 rounded-[14px] border border-[#efb317] bg-[#ffcb23] px-5 py-3 font-semibold text-[#433305] shadow-[0_10px_24px_rgba(255,203,35,0.25)] duration-200"
                            : "min-w-[150px] flex-1 rounded-[14px] border border-[#dfe4db] bg-white px-5 py-3 font-semibold text-[#344054] hover:border-[#efcf7a] duration-200"
                        }
                      >
                        {w}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="grid gap-4 xl:grid-cols-2">
              {/* third box - Pickup Point */}
              <div className="rounded-[24px] border border-[#edf0ea] bg-white px-5 py-5 shadow-[0_16px_40px_rgba(15,23,42,0.08)] sm:px-6 sm:py-6">
                <h1 className="text-[28px] mb-1 font-bold tracking-[-0.03em] text-[#111827]">
                  Pickup Point
                </h1>
                <div className="w-full flex flex-col items-start">
                  <label
                    htmlFor={"pickup"}
                    className="pb-1 lg:text-base text-sm"
                  >
                    Pickup Address<span className="text-red-500">*</span>
                  </label>
                  <div className="relative w-full">
                    <NearbyPlacesAutocomplete
                      value={pickup.text}
                      onChange={(text) => {
                        setPickup((current) =>
                          resetLocationSearch(current, text),
                        );
                        clearFieldErrors("pickup_search");
                      }}
                      onSelect={handlePickupSelect}
                      onServiceabilityRejected={openServiceabilityModal}
                      onServiceabilityError={(error) =>
                        toast.error(error.message)
                      }
                      debounceMs={300}
                      id="pickup"
                      name="create-order-pickup-location-search"
                      required={true}
                      placeholder="Pick your pickup address"
                      containerClassName="relative w-full"
                      className={`min-h-[88px] w-full resize-none rounded-2xl border-2 bg-white px-4 py-4 pr-20 text-sm leading-6 outline-none sm:pr-24 sm:text-base ${formErrors.pickup_search ? "border-red-500" : "border-accentYellow"}`}
                      dropdownClassName="absolute autocomplete-dropdown-container w-full shadow-lg z-10 mt-1"
                      suggestionClassName="suggestion-item px-3 py-3 cursor-pointer hover:bg-gray-50"
                      activeSuggestionClassName="suggestion-item--active px-3 py-3 cursor-pointer hover:bg-gray-100"
                      loadingClassName="w-full px-3 py-3 bg-white rounded-lg"
                      multiline
                      rows={3}
                      autoComplete="new-password"
                      rightAdornment={
                        <div className="absolute right-3 top-1/2 flex -translate-y-1/2 flex-col items-center gap-1.5">
                          {pickup.text ? (
                            <button
                              type="button"
                              onClick={() => clearLocationSearch("pickup")}
                              className="flex h-8 w-8 items-center justify-center rounded-lg text-slate-500 transition hover:bg-slate-100 hover:text-slate-800"
                              title="Clear pickup address"
                            >
                              <IoIosClose className="text-2xl" />
                            </button>
                          ) : null}
                          <button
                            type="button"
                            onClick={handleGetCurrentLocation}
                            disabled={isFetchingLocation}
                            className={`flex h-10 w-10 items-center justify-center rounded-xl transition-colors ${
                              isFetchingLocation
                                ? "bg-gray-400 cursor-not-allowed text-white"
                                : "bg-accentYellow text-[#111827] hover:bg-accentYellow/90"
                            }`}
                            title="Use Current Location"
                          >
                            {isFetchingLocation ? (
                              <svg
                                className="animate-spin h-5 w-5 text-white"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                ></circle>
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                ></path>
                              </svg>
                            ) : (
                              <MdMyLocation className="text-xl" />
                            )}
                          </button>
                        </div>
                      }
                    />
                  </div>
                  {formErrors.pickup_search && (
                    <p className="text-red-500 text-xs mt-1">
                      {formErrors.pickup_search}
                    </p>
                  )}
                </div>

                {pickup.latitude > 0 && (
                  <div className="w-full p-3 bg-green-50 border border-green-200 rounded-lg">
                    <p className="text-sm text-green-800">
                      ✓ Pickup location selected:{" "}
                      {pickup.address?.substring(0, 50)}
                      {pickup.address?.length > 50 ? "..." : ""}
                    </p>
                  </div>
                )}

                <input
                  type="hidden"
                  id="pickup-address"
                  value={pickup.address}
                  readOnly
                />

                <Input
                  required={false}
                  onChange={(e) => {
                    setPickup({ ...pickup, building_and_flat: e.target.value });
                  }}
                  value={pickup.building_and_flat}
                  label={"Building / Wing / Flat No."}
                  type={"text"}
                  placeholder={"Enter building, wing or flat number"}
                  id={"building_and_flat"}
                />

                <div
                  className={
                    formState.delivery_type == "scheduled"
                      ? "grid lg:grid-cols-3 gap-4"
                      : "hidden"
                  }
                >
                  <Input
                    required={formState.delivery_type == "scheduled"}
                    onChange={(e) => {
                      handlePickupDateChange(e.target.value);
                    }}
                    value={pickup.date}
                    label={
                      <>
                        Date<span className="text-red-500">*</span>
                      </>
                    }
                    type={"date"}
                    placeholder={"Enter your Date"}
                    id={"date"}
                    min={pickupDateMin}
                    max={pickupDateMax}
                    error={formErrors.pickup_date}
                  />
                  <Input
                    required={formState.delivery_type == "scheduled"}
                    onChange={(e) => {
                      const fromtime = e.target.value;
                      const requiredFromTime =
                        getRequiredFromTimeForStop("pickup");
                      const maximumFromTime =
                        getMaximumFromTimeForStop("pickup");
                      if (
                        requiredFromTime &&
                        compareTimeValues(fromtime, requiredFromTime) === -1
                      ) {
                        toast.error("Can't select time before current time.");
                        return;
                      }
                      if (
                        maximumFromTime &&
                        compareTimeValues(fromtime, maximumFromTime) === 1
                      ) {
                        toast.error(
                          "Please select an earlier pickup time for the same day.",
                        );
                        return;
                      }

                      const minimumToTime = getMinimumToTimeForStop(
                        "pickup",
                        null,
                        fromtime,
                      );
                      if (!minimumToTime) {
                        toast.error(
                          "No valid pickup time window is available in the same day.",
                        );
                        return;
                      }

                      syncScheduledRouteTimesFromPickup(fromtime);
                      clearFieldErrors("pickup_fromtime", "pickup_totime");
                    }}
                    value={pickup.fromtime}
                    label={
                      <>
                        From Time<span className="text-red-500">*</span>
                      </>
                    }
                    type={"time"}
                    placeholder={"Select start time"}
                    id={"fromtime"}
                    min={getRequiredFromTimeForStop("pickup") || undefined}
                    inputMode="none"
                    onKeyDown={preventManualTimeTyping}
                    onPaste={preventManualTimeTyping}
                    max={getMaximumFromTimeForStop("pickup") || undefined}
                    error={formErrors.pickup_fromtime}
                  />
                  <Input
                    required={formState.delivery_type == "scheduled"}
                    onChange={(e) => {
                      const nextToTime = e.target.value;
                      const minimumToTime = getMinimumToTimeForStop("pickup");
                      if (
                        minimumToTime &&
                        compareTimeValues(nextToTime, minimumToTime) === -1
                      ) {
                        toast.error(
                          `Pickup to time can't be before ${minimumToTime}.`,
                        );
                        return;
                      }

                      setPickup((current) => ({
                        ...current,
                        totime: nextToTime,
                      }));
                      clearFieldErrors("pickup_totime");
                    }}
                    value={pickup.totime}
                    label={
                      <>
                        To Time<span className="text-red-500">*</span>
                      </>
                    }
                    type={"time"}
                    placeholder={"Select end time"}
                    id={"totime"}
                    inputMode="none"
                    onKeyDown={preventManualTimeTyping}
                    onPaste={preventManualTimeTyping}
                    min={getMinimumToTimeForStop("pickup") || undefined}
                    max={"23:59"}
                    error={formErrors.pickup_totime}
                  />
                </div>

                <div className="grid lg:grid-cols-2 gap-4">
                  {renderPrefixedPhoneInput({
                    value: pickup.phone_number,
                    onChange: (text) => {
                      setPickup({ ...pickup, phone_number: text });
                      updatePhoneFieldError("pickup_phone_number", text);
                    },
                    label: (
                      <>
                        Mobile Number<span className="text-red-500">*</span>
                      </>
                    ),
                    id: "phone_number",
                    error: formErrors.pickup_phone_number,
                  })}
                  <Input
                    required={true}
                    onChange={(e) => {
                      setPickup({ ...pickup, name: e.target.value });
                      clearFieldErrors("pickup_name");
                    }}
                    value={pickup.name}
                    label={
                      <>
                        Name<span className="text-red-500">*</span>
                      </>
                    }
                    type={"text"}
                    placeholder={"Enter your name"}
                    id={"name"}
                    error={formErrors.pickup_name}
                  />
                </div>
                <Input
                  onChange={(e) => {
                    setPickup({ ...pickup, instructions: e.target.value });
                  }}
                  value={pickup.instructions}
                  label={"Instructions"}
                  type={"text"}
                  placeholder={"Special delivery instructions"}
                  id={"instructions"}
                />
              </div>

              {/* fourth box - Drop Point */}
              <div className="rounded-[24px] border border-[#edf0ea] bg-white px-5 py-5 shadow-[0_16px_40px_rgba(15,23,42,0.08)] sm:px-6 sm:py-6">
                <h1 className="text-[28px] mb-1 font-bold tracking-[-0.03em] text-[#111827]">
                  Drop Point
                </h1>
                <div className="w-full flex flex-col items-start">
                  <label htmlFor={"drop"} className="pb-1 text-sm lg:text-base">
                    Drop Address<span className="text-red-500">*</span>
                  </label>
                  <NearbyPlacesAutocomplete
                    value={drop.text}
                    onChange={(text) => {
                      setDrop((current) => resetLocationSearch(current, text));
                      clearFieldErrors("drop_search");
                    }}
                    onSelect={handleDropSelect}
                    onServiceabilityRejected={openServiceabilityModal}
                    onServiceabilityError={(error) =>
                      toast.error(error.message)
                    }
                    debounceMs={300}
                    id="drop"
                    name="create-order-drop-location-search"
                    required={true}
                    placeholder="Pick your drop address"
                    containerClassName="relative w-full"
                    className={`min-h-[88px] w-full resize-none rounded-2xl border-2 bg-white px-4 py-4 pr-14 text-sm leading-6 outline-none sm:pr-16 sm:text-base ${formErrors.drop_search ? "border-red-500" : "border-accentYellow"}`}
                    dropdownClassName="absolute autocomplete-dropdown-container w-full shadow-lg z-10 mt-1"
                    suggestionClassName="suggestion-item px-3 py-3 cursor-pointer hover:bg-gray-50"
                    activeSuggestionClassName="suggestion-item--active px-3 py-3 cursor-pointer hover:bg-gray-100"
                    loadingClassName="w-full px-3 py-3 bg-white rounded-lg"
                    multiline
                    rows={3}
                    autoComplete="new-password"
                    rightAdornment={
                      drop.text ? (
                        <button
                          type="button"
                          onClick={() => clearLocationSearch("drop")}
                          className="absolute right-3 top-2 flex h-8 w-8 items-center justify-center rounded-lg text-slate-500 transition hover:bg-slate-100 hover:text-slate-800"
                          title="Clear drop address"
                        >
                          <IoIosClose className="text-2xl" />
                        </button>
                      ) : null
                    }
                  />
                  {formErrors.drop_search && (
                    <p className="text-red-500 text-xs mt-1">
                      {formErrors.drop_search}
                    </p>
                  )}
                </div>

                {drop.latitude > 0 && (
                  <div className="w-full p-3 bg-green-50 border border-green-200 rounded-lg">
                    <p className="text-sm text-green-800">
                      ✓ Drop location selected: {drop.address?.substring(0, 50)}
                      {drop.address?.length > 50 ? "..." : ""}
                    </p>
                  </div>
                )}

                <input
                  type="hidden"
                  id="drop-address"
                  value={drop.address}
                  readOnly
                />

                <Input
                  required={false}
                  onChange={(e) => {
                    setDrop({ ...drop, building_and_flat: e.target.value });
                  }}
                  value={drop.building_and_flat}
                  label={"Building / Wing / Flat No."}
                  type={"text"}
                  placeholder={"Enter building, wing or flat number"}
                  id={"drop-building-and-flat"}
                />

                <div
                  className={
                    formState.delivery_type == "scheduled"
                      ? "grid lg:grid-cols-3 gap-4"
                      : "hidden"
                  }
                >
                  <Input
                    required={formState.delivery_type == "scheduled"}
                    onChange={() => {}}
                    value={drop.date}
                    label={
                      <>
                        Date<span className="text-red-500">*</span>
                      </>
                    }
                    type={"date"}
                    placeholder={"Enter your Date"}
                    id={"drop-date"}
                    readOnly
                    disabled
                  />
                  <Input
                    required={false}
                    onChange={(e) => {
                      const fromtime = e.target.value;
                      const requiredFromTime =
                        getRequiredFromTimeForStop("drop");
                      const maximumFromTime = getMaximumFromTimeForStop("drop");

                      if (
                        requiredFromTime &&
                        compareTimeValues(fromtime, requiredFromTime) === -1
                      ) {
                        toast.error("Can't select time before pickup time.");
                        return;
                      }

                      if (
                        maximumFromTime &&
                        compareTimeValues(fromtime, maximumFromTime) === 1
                      ) {
                        toast.error(
                          "Please select an earlier drop time for the same day.",
                        );
                        return;
                      }

                      const minimumToTime = getMinimumToTimeForStop(
                        "drop",
                        null,
                        fromtime,
                      );
                      if (!minimumToTime) {
                        toast.error(
                          "No valid drop time window is available in the same day.",
                        );
                        return;
                      }

                      setDrop((current) => ({
                        ...current,
                        fromtime,
                        time: fromtime,
                        totime:
                          !current.totime ||
                          compareTimeValues(current.totime, minimumToTime) ===
                            -1
                            ? minimumToTime
                            : current.totime,
                      }));
                      clearFieldErrors("drop_fromtime", "drop_totime");
                    }}
                    value={drop.fromtime}
                    label={<>From Time</>}
                    type={"time"}
                    placeholder={"Select start time"}
                    id={"drop-fromtime"}
                    inputMode="none"
                    onKeyDown={preventManualTimeTyping}
                    onPaste={preventManualTimeTyping}
                    min={getRequiredFromTimeForStop("drop") || undefined}
                    max={getMaximumFromTimeForStop("drop") || undefined}
                    error={formErrors.drop_fromtime}
                  />
                  <Input
                    required={false}
                    onChange={(e) => {
                      const nextToTime = e.target.value;
                      const minimumToTime = getMinimumToTimeForStop("drop");
                      if (
                        minimumToTime &&
                        compareTimeValues(nextToTime, minimumToTime) === -1
                      ) {
                        toast.error(
                          getDropTimeErrorMessage(getSegmentMinimumMinutes(0)),
                        );
                        return;
                      }

                      setDrop({ ...drop, totime: nextToTime });
                      clearFieldErrors("drop_totime");
                    }}
                    value={drop.totime}
                    label={<>To Time</>}
                    type={"time"}
                    placeholder={"Select end time"}
                    id={"drop-totime"}
                    inputMode="none"
                    onKeyDown={preventManualTimeTyping}
                    onPaste={preventManualTimeTyping}
                    min={getMinimumToTimeForStop("drop") || undefined}
                    max={"23:59"}
                    error={formErrors.drop_totime}
                  />
                </div>

                <div className="grid lg:grid-cols-2 gap-4">
                  {renderPrefixedPhoneInput({
                    value: drop.phone_number,
                    onChange: (text) => {
                      setDrop({ ...drop, phone_number: text });
                      updatePhoneFieldError("drop_phone_number", text);
                    },
                    label: (
                      <>
                        Mobile Number<span className="text-red-500">*</span>
                      </>
                    ),
                    id: "phone_number",
                    error: formErrors.drop_phone_number,
                  })}
                  <Input
                    required={true}
                    onChange={(e) => {
                      setDrop({ ...drop, name: e.target.value });
                      clearFieldErrors("drop_name");
                    }}
                    value={drop.name}
                    label={
                      <>
                        Name<span className="text-red-500">*</span>
                      </>
                    }
                    type={"text"}
                    placeholder={"Enter your name"}
                    id={"name"}
                    error={formErrors.drop_name}
                  />
                </div>
                <Input
                  onChange={(e) => {
                    setDrop({ ...drop, instructions: e.target.value });
                  }}
                  value={drop.instructions}
                  label={"Instructions"}
                  type={"text"}
                  placeholder={"Special delivery instructions"}
                  id={"instructions"}
                />
              </div>
            </div>

            {/* Additional Drop Locations */}
            {droplocations?.map((droplocation, index) => (
              <div
                key={index}
                className="border-accentYellow border-2 bg-white lg:w-[80%] w-full h-auto flex flex-col lg:gap-3 gap-3 my-4 lg:py-8 py-4 lg:px-10 px-4 rounded-2xl"
              >
                <div className="flex justify-between items-center mb-4">
                  <h1 className="text-xl font-bold">Drop Point {index + 2}</h1>
                  <span
                    onClick={() => handleRemove(index)}
                    className="flex justify-center items-center h-8 w-8 bg-red-500 text-white rounded-md cursor-pointer hover:bg-red-600 transition-colors"
                    title="Remove drop point"
                  >
                    <FiTrash2 className="text-lg" />
                  </span>
                </div>

                <div className="w-full flex flex-col items-start">
                  <label
                    htmlFor={`droppoint-${index}`}
                    className="pb-1 text-sm lg:text-base"
                  >
                    Drop Address<span className="text-red-500">*</span>
                  </label>
                  <NearbyPlacesAutocomplete
                    value={droplocation.text}
                    onChange={(text) => {
                      setDroplocations((current) =>
                        current.map((item, itemIndex) =>
                          itemIndex === index
                            ? resetLocationSearch(item, text)
                            : item,
                        ),
                      );
                      clearFieldErrors(getDropPointErrorKey("search", index));
                    }}
                    onSelect={(location) =>
                      handleDropLocationSelect(index, location)
                    }
                    onServiceabilityRejected={openServiceabilityModal}
                    onServiceabilityError={(error) =>
                      toast.error(error.message)
                    }
                    debounceMs={300}
                    id={`droppoint-${index}`}
                    name={`create-order-drop-point-search-${index}`}
                    required={true}
                    placeholder="Pick your drop address"
                    containerClassName="relative w-full"
                    className={`min-h-[88px] w-full resize-none rounded-2xl border-2 bg-white px-4 py-4 pr-14 text-sm leading-6 outline-none sm:pr-16 sm:text-base ${formErrors[getDropPointErrorKey("search", index)] ? "border-red-500" : "border-accentYellow"}`}
                    dropdownClassName="absolute autocomplete-dropdown-container w-full shadow-lg z-10 mt-1"
                    suggestionClassName="suggestion-item px-3 py-3 cursor-pointer hover:bg-gray-50"
                    activeSuggestionClassName="suggestion-item--active px-3 py-3 cursor-pointer hover:bg-gray-100"
                    loadingClassName="w-full px-3 py-3 bg-white rounded-lg"
                    multiline
                    rows={3}
                    autoComplete="new-password"
                    rightAdornment={
                      droplocation.text ? (
                        <button
                          type="button"
                          onClick={() =>
                            clearLocationSearch("droppoint", index)
                          }
                          className="absolute right-3 top-2 flex h-8 w-8 items-center justify-center rounded-lg text-slate-500 transition hover:bg-slate-100 hover:text-slate-800"
                          title="Clear delivery point address"
                        >
                          <IoIosClose className="text-2xl" />
                        </button>
                      ) : null
                    }
                  />
                  {formErrors[getDropPointErrorKey("search", index)] && (
                    <p className="text-red-500 text-xs mt-1">
                      {formErrors[getDropPointErrorKey("search", index)]}
                    </p>
                  )}
                </div>

                {droplocation.latitude > 0 && (
                  <div className="w-full p-3 bg-green-50 border border-green-200 rounded-lg">
                    <p className="text-sm text-green-800">
                      ✓ Drop location selected:{" "}
                      {droplocation.address?.substring(0, 50)}
                      {droplocation.address?.length > 50 ? "..." : ""}
                    </p>
                  </div>
                )}

                <input
                  type="hidden"
                  id={`drop-address-${index}`}
                  value={droplocation?.address || ""}
                  readOnly
                />

                <Input
                  required={false}
                  onChange={(e) =>
                    handleDropLocationChange(
                      index,
                      "building_and_flat",
                      e.target.value,
                    )
                  }
                  value={droplocation?.building_and_flat}
                  label={"Building / Wing / Flat No."}
                  type={"text"}
                  placeholder={"Enter building, wing or flat number"}
                  id={`building_and_flat-${index}`}
                />

                <div
                  className={
                    formState.delivery_type == "scheduled"
                      ? "grid lg:grid-cols-3 gap-4"
                      : "hidden"
                  }
                >
                  <Input
                    required={formState.delivery_type == "scheduled"}
                    onChange={() => {}}
                    value={droplocation?.date}
                    label={
                      <>
                        Date<span className="text-red-500">*</span>
                      </>
                    }
                    type={"date"}
                    placeholder={"Enter your Date"}
                    id={`date-${index}`}
                    readOnly
                    disabled
                  />
                  <Input
                    required={false}
                    onChange={(e) => {
                      const fromtime = e.target.value;
                      const requiredFromTime = getRequiredFromTimeForStop(
                        "droppoint",
                        index,
                      );
                      const maximumFromTime = getMaximumFromTimeForStop(
                        "droppoint",
                        index,
                      );

                      if (
                        requiredFromTime &&
                        compareTimeValues(fromtime, requiredFromTime) === -1
                      ) {
                        toast.error(
                          "Can't select time before previous drop time.",
                        );
                        return;
                      }

                      if (
                        maximumFromTime &&
                        compareTimeValues(fromtime, maximumFromTime) === 1
                      ) {
                        toast.error(
                          "Please select an earlier drop time for the same day.",
                        );
                        return;
                      }

                      const minimumToTime = getMinimumToTimeForStop(
                        "droppoint",
                        index,
                        fromtime,
                      );
                      if (!minimumToTime) {
                        toast.error(
                          "No valid drop time window is available in the same day.",
                        );
                        return;
                      }

                      handleDropLocationChange(index, "fromtime", fromtime);
                      handleDropLocationChange(index, "time", fromtime);
                      handleDropLocationChange(
                        index,
                        "totime",
                        !droplocation?.totime ||
                          compareTimeValues(
                            droplocation?.totime,
                            minimumToTime,
                          ) === -1
                          ? minimumToTime
                          : droplocation?.totime,
                      );
                      clearFieldErrors(
                        getDropPointErrorKey("fromtime", index),
                        getDropPointErrorKey("totime", index),
                      );
                    }}
                    value={droplocation?.fromtime}
                    label={<>From Time</>}
                    type={"time"}
                    placeholder={"Select start time"}
                    id={`fromtime-${index}`}
                    inputMode="none"
                    onKeyDown={preventManualTimeTyping}
                    onPaste={preventManualTimeTyping}
                    min={
                      getRequiredFromTimeForStop("droppoint", index) ||
                      undefined
                    }
                    max={
                      getMaximumFromTimeForStop("droppoint", index) || undefined
                    }
                    error={formErrors[getDropPointErrorKey("fromtime", index)]}
                  />
                  <Input
                    required={false}
                    onChange={(e) => {
                      const nextToTime = e.target.value;
                      const minimumToTime = getMinimumToTimeForStop(
                        "droppoint",
                        index,
                      );
                      if (
                        minimumToTime &&
                        compareTimeValues(nextToTime, minimumToTime) === -1
                      ) {
                        toast.error(
                          getDropTimeErrorMessage(
                            getSegmentMinimumMinutes(index + 1),
                          ),
                        );
                        return;
                      }

                      handleDropLocationChange(index, "totime", nextToTime);
                      clearFieldErrors(getDropPointErrorKey("totime", index));
                    }}
                    value={droplocation?.totime}
                    label={<>To Time</>}
                    type={"time"}
                    placeholder={"Select end time"}
                    id={`totime-${index}`}
                    inputMode="none"
                    onKeyDown={preventManualTimeTyping}
                    onPaste={preventManualTimeTyping}
                    min={
                      getMinimumToTimeForStop("droppoint", index) || undefined
                    }
                    max={"23:59"}
                    error={formErrors[getDropPointErrorKey("totime", index)]}
                  />
                </div>

                <div className="grid lg:grid-cols-2 gap-4">
                  {renderPrefixedPhoneInput({
                    value: droplocation?.phone_number,
                    onChange: (text) => {
                      handleDropLocationChange(index, "phone_number", text);
                      updatePhoneFieldError(
                        getDropPointErrorKey("phone_number", index),
                        text,
                      );
                    },
                    label: (
                      <>
                        Mobile Number<span className="text-red-500">*</span>
                      </>
                    ),
                    id: `phone_number-${index}`,
                    error:
                      formErrors[getDropPointErrorKey("phone_number", index)],
                  })}
                  <Input
                    required={true}
                    onChange={(e) =>
                      handleDropLocationChange(index, "name", e.target.value)
                    }
                    value={droplocation?.name}
                    label={
                      <>
                        Name<span className="text-red-500">*</span>
                      </>
                    }
                    type={"text"}
                    placeholder={"Enter your name"}
                    id={`name-${index}`}
                    error={formErrors[getDropPointErrorKey("name", index)]}
                  />
                </div>
                <Input
                  onChange={(e) =>
                    handleDropLocationChange(
                      index,
                      "instructions",
                      e.target.value,
                    )
                  }
                  value={droplocation?.instructions}
                  label={"Instructions"}
                  type={"text"}
                  placeholder={"Special delivery instructions"}
                  id={`instructions-${index}`}
                />
              </div>
            ))}
            {/* fifth box - Add Delivery Point */}
            {formState.delivery_type !== "flexible" && (
              <div
                onClick={handleAddDeliveryPoint}
                className="flex w-full cursor-pointer items-center justify-center rounded-[20px] border border-[#efb317] bg-[linear-gradient(180deg,#fff9ea_0%,#fff5dd_100%)] px-6 py-4 text-center shadow-[0_10px_28px_rgba(255,201,52,0.14)] transition hover:shadow-[0_14px_34px_rgba(255,201,52,0.2)]"
              >
                <h1 className="flex items-center justify-center gap-3 text-xl font-bold text-[#1f2937]">
                  <FiPlusCircle className="text-[22px] text-[#374151]" />
                  Add a Delivery Point
                </h1>
              </div>
            )}

            <div className="grid gap-4 xl:grid-cols-2">
              {/* sixth box - Package Details */}
              <div className="rounded-[24px] border border-[#edf0ea] bg-white px-5 py-5 shadow-[0_16px_40px_rgba(15,23,42,0.08)] sm:px-6 sm:py-6">
                <h1 className="mb-1 flex items-center gap-3 text-[28px] font-bold tracking-[-0.03em] text-[#111827]">
                  <FiBox className="text-[#d5a21b]" />
                  What Commodity are you Sending?
                </h1>
                <Input
                  required={true}
                  onChange={handleChange}
                  value={formState.package}
                  type={"text"}
                  placeholder={
                    "E.g., Cake, Fruits, Clothes, Documents, Flowers, Vegetables, etc."
                  }
                  id={"package"}
                  label={
                    <>
                      Package Type<span className="text-red-500">*</span>
                    </>
                  }
                  error={formErrors.package}
                />
                <div className="mt-4 flex flex-wrap gap-3">
                  {QUICK_PACKAGE_OPTIONS.map((packageType) => {
                    const isSelected =
                      formState.package.trim().toLowerCase() ===
                      packageType.toLowerCase();

                    return (
                      <button
                        key={packageType}
                        type="button"
                        onClick={() => handleQuickPackageSelect(packageType)}
                        className={
                          isSelected
                            ? "rounded-full border border-[#efb317] bg-[#ffcb23] px-4 py-2.5 text-sm font-semibold text-[#433305] shadow-[0_10px_24px_rgba(255,203,35,0.2)] transition"
                            : "rounded-full border border-[#dfe4db] bg-white px-4 py-2.5 text-sm font-semibold text-[#344054] transition hover:border-[#efcf7a] hover:bg-[#fff9ea]"
                        }
                      >
                        {packageType}
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* seventh box - Insurance */}
              <div className="rounded-[24px] border border-[#edf0ea] bg-white px-5 py-5 shadow-[0_16px_40px_rgba(15,23,42,0.08)] sm:px-6 sm:py-6">
                <h1 className="mb-1 flex items-center gap-3 text-[28px] font-bold tracking-[-0.03em] text-[#111827]">
                  <FiShield className="text-[#3f7d2d]" />
                  Insurance of Parcel
                </h1>
                <div className="flex flex-col w-full gap-3 items-end">
                  <Input
                    required={true}
                    onChange={handleChange}
                    value={formState.parcel_value}
                    label={
                      <>
                        Parcel Value ({"\u20B9"})
                        <span className="text-red-500">*</span>
                      </>
                    }
                    type={"number"}
                    placeholder={`Enter parcel value (${"\u20B9"}1 - ${"\u20B9"}30000)`}
                    id={"parcel_value"}
                    min={1}
                    max={30000}
                    error={formErrors.parcel_value}
                  />
                  <p className="w-full text-sm leading-6 text-gray-500">
                    * Insurance: 1% of declared value (up to {"\u20B9"}30,000
                    coverage)
                  </p>
                </div>
                <Input
                  required={true}
                  onChange={(e) => {
                    let text = formatPhoneNumber(e.target.value);
                    setFormState({
                      ...formState,
                      phone_number: text,
                    });
                    updatePhoneFieldError("phone_number", text);
                  }}
                  value={formState.phone_number}
                  label={
                    <>
                      Mobile Number<span className="text-red-500">*</span>
                    </>
                  }
                  type={"text"}
                  placeholder={"Enter phone number"}
                  id={"phone_number"}
                  error={formErrors.phone_number}
                />
                <p className="text-sm leading-6 text-gray-500">
                  Secure any delicate or crucial packages so that you may
                  recover the value in the event that they are lost or damaged
                  during delivery.
                </p>
              </div>
            </div>

            {/* Vehicle Selection */}
            <div className="rounded-[24px] border border-[#edf0ea] bg-white px-5 py-5 shadow-[0_16px_40px_rgba(15,23,42,0.08)] sm:px-6 sm:py-6">
              <h1 className="mb-1 text-[28px] font-bold tracking-[-0.03em] text-[#111827]">
                Select Vehicle Type
              </h1>
              <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
                <div
                  onClick={() => {
                    setFormState({ ...formState, vehicle: "scooty" });
                  }}
                  className={
                    formState.vehicle === "scooty"
                      ? "cursor-pointer rounded-[22px] border border-[#efb317] bg-[linear-gradient(180deg,#fff9e7_0%,#fff2c9_100%)] p-5 transition-all"
                      : "cursor-pointer rounded-[22px] border border-[#edf0ea] bg-white p-5 transition-all hover:border-[#efcf7a]"
                  }
                >
                  <div className="flex items-center justify-between gap-4">
                    <div className="flex items-center gap-4">
                      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#ffcb23] text-[#fff] shadow-[0_8px_18px_rgba(255,203,35,0.28)]">
                        <MdElectricScooter
                          className="h-8 w-8"
                          aria-hidden="true"
                        />
                      </div>
                      <div>
                        <h3 className="text-[28px] font-bold tracking-[-0.03em] text-[#111827]">
                          Scooter
                        </h3>
                        <p className="text-base text-gray-600">
                          For high capacity delivery
                        </p>
                      </div>
                    </div>
                    <div
                      className={`flex h-7 w-7 items-center justify-center rounded-full border ${formState.vehicle === "scooty" ? "border-[#efb317] bg-[#ffcb23] text-white" : "border-[#d6dbe1] bg-white text-transparent"}`}
                    >
                      <FiCheck className="text-sm" />
                    </div>
                  </div>
                </div>
                <div
                  onClick={() => {
                    setFormState({ ...formState, vehicle: "bike" });
                  }}
                  className={
                    formState.vehicle === "bike"
                      ? "cursor-pointer rounded-[22px] border border-[#efb317] bg-[linear-gradient(180deg,#fff9e7_0%,#fff2c9_100%)] p-5 transition-all"
                      : "cursor-pointer rounded-[22px] border border-[#edf0ea] bg-white p-5 transition-all hover:border-[#efcf7a]"
                  }
                >
                  <div className="flex items-center justify-between gap-4">
                    <div className="flex items-center gap-4">
                      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#285f1e] text-[#fff] shadow-[0_8px_18px_rgba(40,95,30,0.22)]">
                        <MdTwoWheeler className="h-8 w-8" aria-hidden="true" />
                      </div>
                      <div>
                        <h3 className="text-[28px] font-bold tracking-[-0.03em] text-[#111827]">
                          Bike
                        </h3>
                        <p className="text-base text-gray-600">
                          For low capacity delivery
                        </p>
                      </div>
                    </div>
                    <div
                      className={`flex h-7 w-7 items-center justify-center rounded-full border ${formState.vehicle === "bike" ? "border-[#efb317] bg-[#ffcb23] text-white" : "border-[#d6dbe1] bg-white text-transparent"}`}
                    >
                      <FiCheck className="text-sm" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-center py-3">
              <button
                type="submit"
                disabled={isPreparingOrder}
                className={`flex min-w-[320px] items-center justify-center gap-4 rounded-[16px] bg-[linear-gradient(180deg,#315f1f_0%,#214d14_100%)] px-10 py-4 text-center text-[31px] font-bold tracking-[-0.03em] text-white shadow-[0_16px_34px_rgba(36,86,24,0.22)] transition ${isPreparingOrder ? "cursor-not-allowed opacity-75" : "hover:translate-y-[-1px] hover:shadow-[0_20px_40px_rgba(36,86,24,0.28)]"}`}
              >
                {isPreparingOrder
                  ? "Preparing Order..."
                  : amount > 0
                    ? `Place Order - ${"\u20B9"}${amount.toFixed(0)}`
                    : "Place Order"}
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-[#29571c]">
                  {isPreparingOrder ? (
                    <span className="h-4 w-4 animate-spin rounded-full border-2 border-[#29571c] border-t-transparent" />
                  ) : (
                    <FiArrowRight className="text-lg" />
                  )}
                </span>
              </button>
            </div>

            <div className="space-y-4">
              <div className="rounded-[24px] border border-[#eef0e7] bg-[linear-gradient(180deg,#fbfdf6_0%,#f6faed_100%)] px-6 py-6 shadow-[0_12px_30px_rgba(15,23,42,0.06)]">
                <div className="flex items-start gap-4">
                  <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[#eef8e9] text-[#2d6a1d]">
                    <FiShield className="text-[26px]" />
                  </div>
                  <div className="text-left">
                    <p className="text-[15px] leading-7 text-[#475467]">
                      By clicking "Place Order", you agree to our{" "}
                      <span className="font-semibold text-[#1f6d23]">
                        Terms & Conditions
                      </span>{" "}
                      and confirm that the information provided is accurate.
                      You'll receive SMS updates and can track your delivery in
                      real-time.
                    </p>
                  </div>
                </div>
              </div>

              <div className="rounded-[24px] border border-[#eef0e7] bg-white px-6 py-8 shadow-[0_16px_40px_rgba(15,23,42,0.06)]">
                <h2 className="text-center text-[38px] font-bold tracking-[-0.04em] text-[#24561a]">
                  Simple Steps to Order
                </h2>
                <div className="mt-8 grid gap-4 md:grid-cols-5">
                  {[
                    {
                      icon: <FiMapPin />,
                      text: "1. Enter pickup and delivery details with accurate addresses",
                    },
                    {
                      icon: <FiCalendar />,
                      text: "2. Review the estimated fare (updates automatically)",
                    },
                    {
                      icon: <FiCheckCircle />,
                      text: '3. Click "Place Order" to confirm',
                    },
                    {
                      icon: <FiPhone />,
                      text: "4. Receive a call from your assigned delivery partner",
                    },
                    {
                      icon: <FiTruck />,
                      text: "5. Track your delivery and rate your experience",
                    },
                  ].map((step, index) => (
                    <div
                      key={index}
                      className="relative flex flex-col items-center text-center"
                    >
                      {index !== 4 && (
                        <div className="absolute left-[64%] top-8 hidden h-px w-[72%] border-t border-dashed border-[#d4d9ce] md:block" />
                      )}
                      <div className="flex h-16 w-16 items-center justify-center rounded-full border border-[#f2d68c] bg-[#fffdf7] text-[27px] text-[#24561a] shadow-[0_8px_22px_rgba(245,196,76,0.12)]">
                        {step.icon}
                      </div>
                      <p className="mt-4 text-sm leading-6 text-[#475467]">
                        {step.text}
                      </p>
                    </div>
                  ))}
                </div>
                <p className="mt-8 text-center text-[33px] font-semibold tracking-[-0.03em] text-[#111827]">
                  Thank you for choosing Instaport!
                </p>
                <p className="mt-1 text-center text-base text-[#8a8f98]">
                  Regards, Team Instaport
                </p>
              </div>
            </div>

            {/* Payment Modal */}
            <section
              className={
                show
                  ? "flex justify-center items-center z-[5000] fixed top-0 left-0 bg-black/40 h-screen w-screen opacity-100 duration-200 pointer-events-auto"
                  : "z-[5000] fixed top-0 left-0 bg-black/40 h-screen w-screen opacity-0 duration-200 pointer-events-none flex justify-center items-center"
              }
            >
              <div className="border-accentYellow border-2 bg-white lg:w-[40%] w-[90%] max-w-md h-auto max-h-[85vh] flex flex-col gap-6 my-4 lg:py-8 py-4 lg:px-10 px-4 rounded-2xl overflow-y-auto">
                <div className="flex justify-between items-center sticky top-0 bg-white pb-2">
                  <h1 className="text-xl text-left w-full font-bold">
                    Payment Type
                  </h1>
                  <span
                    className="cursor-pointer bg-gray-50 hover:bg-gray-100 duration-200 h-8 w-8 flex justify-center items-center rounded-md"
                    onClick={() => setShow(false)}
                  >
                    <IoIosClose className="text-3xl" />
                  </span>
                </div>

                <div className="text-center">
                  <div className="mt-2 pt-2 border-t border-gray-200">
                    <div className="flex justify-between items-center">
                      <div
                        className="flex items-center cursor-pointer"
                        onClick={() => setShowWalletDueInfo(!showWalletDueInfo)}
                      >
                        <span className="text-sm font-medium text-gray-800">
                          Order Amount
                        </span>
                      </div>
                      <span className="text-sm font-semibold text-gray-800">
                        {"\u20B9"}
                        {orderAmount.toFixed(0)}
                      </span>
                    </div>
                    {flexibleDeliveryDiscountAmount > 0 && (
                      <div className="flex justify-between items-center mt-1">
                        <span className="text-sm font-medium text-green-600">
                          Flexible delivery discount ({flexibleDiscountPercent}
                          %)
                        </span>
                        <span className="text-sm font-semibold text-green-600">
                          - {"\u20B9"}
                          {flexibleDeliveryDiscountAmount.toFixed(0)}
                        </span>
                      </div>
                    )}
                    {securityFeeAmount > 0 && (
                      <div className="flex justify-between items-center mt-1">
                        <div className="flex items-center gap-1">
                          <span className="text-sm font-medium text-gray-800">
                            Security Fee
                          </span>
                          <SecurityFeeInfoButton iconClassName="text-gray-500 text-xs" />
                        </div>
                        <span className="text-sm font-semibold text-gray-800">
                          {"\u20B9"}
                          {securityFeeAmount.toFixed(0)}
                        </span>
                      </div>
                    )}

                    {hasWalletDue && (
                      <div className="flex justify-between items-center mt-1">
                        <div
                          className="flex items-center cursor-pointer"
                          onClick={() =>
                            setShowWalletDueInfo(!showWalletDueInfo)
                          }
                        >
                          <span className="text-sm font-medium text-red-600">
                            Wallet Due
                          </span>
                          <FiInfo className="ml-1 text-red-500 text-xs" />
                        </div>
                        <span className="text-sm font-semibold text-red-600">
                          {"\u20B9"}
                          {walletDue.toFixed(0)}
                        </span>
                      </div>
                    )}

                    {showWalletDueInfo && (
                      <div className="mt-1 text-xs text-gray-500 bg-red-50 p-2 rounded">
                        This amount represents your negative wallet balance from
                        previous orders. It will be added to your current order
                        total.
                      </div>
                    )}
                  </div>
                  <div className="text-3xl font-bold text-accentYellow mb-2">
                    {"\u20B9"}
                    {amount.toFixed(0)}
                  </div>
                  <p className="text-sm text-gray-600">Total Estimated Fare</p>
                </div>

                {payment == "cod" && (
                  <div className="flex flex-col gap-3">
                    <h2 className="text-lg text-left w-full font-bold mb-1">
                      Select Payment Collection Address
                      <span className="text-red-500">*</span>
                    </h2>
                    {payment === "cod" && !paymentAddress && (
                      <p className="text-red-500 text-sm -mt-2">
                        Please select a payment collection address
                      </p>
                    )}
                    <div className="flex flex-col gap-2 max-h-48 overflow-y-auto">
                      <div
                        onClick={() => {
                          setPaymentAddress(pickup);
                        }}
                        className={`px-4 py-3 bg-white border-2 rounded-lg cursor-pointer hover:shadow-sm transition-all ${
                          paymentAddress?.key == pickup.key
                            ? "border-accentYellow bg-accentYellow/10"
                            : "border-gray-200"
                        }`}
                      >
                        <p className="font-medium">Pickup Address</p>
                        <p className="text-sm text-gray-600 truncate">
                          {pickup?.address || "Not selected"}
                        </p>
                      </div>
                      <div
                        onClick={() => {
                          setPaymentAddress(drop);
                        }}
                        className={`px-4 py-3 bg-white border-2 rounded-lg cursor-pointer hover:shadow-sm transition-all ${
                          paymentAddress?.key == drop.key
                            ? "border-accentYellow bg-accentYellow/10"
                            : "border-gray-200"
                        }`}
                      >
                        <p className="font-medium">Main Drop Address</p>
                        <p className="text-sm text-gray-600 truncate">
                          {drop?.address || "Not selected"}
                        </p>
                      </div>
                      {droplocations.map((droppoint, index) => (
                        <div
                          key={index}
                          onClick={() => {
                            setPaymentAddress(droppoint);
                          }}
                          className={`px-4 py-3 bg-white border-2 rounded-lg cursor-pointer hover:shadow-sm transition-all ${
                            paymentAddress?.key == droppoint?.key
                              ? "border-accentYellow bg-accentYellow/10"
                              : "border-gray-200"
                          }`}
                        >
                          <p className="font-medium">
                            Additional Drop {index + 1}
                          </p>
                          <p className="text-sm text-gray-600 truncate">
                            {droppoint?.address || "Not selected"}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div className="w-full flex justify-center gap-1 sm:gap-6">
                  {Number(userData?.wallet || 0) > 0 && (
                    <button
                      type="button"
                      onClick={() => {
                        setPayment("wallet");
                      }}
                      className={`flex-1 outline-none rounded-xl
        px-1 sm:px-7
        py-2
        text-[11px] sm:text-base
        leading-snug sm:leading-normal
        text-center whitespace-normal break-normal
        font-medium transition-all duration-200
        ${
          payment === "wallet"
            ? "bg-accentYellow text-white shadow-md"
            : "bg-white border-2 border-accentYellow text-accentYellow hover:bg-accentYellow/5"
        }`}
                    >
                      Wallet
                    </button>
                  )}

                  <button
                    type="button"
                    onClick={() => {
                      setPayment("online");
                    }}
                    className={`flex-1 outline-none rounded-xl
      px-1 sm:px-7
      py-2
      text-[11px] sm:text-base
      leading-snug sm:leading-normal
      text-center whitespace-normal break-normal
      font-medium transition-all duration-200
      ${
        payment === "online"
          ? "bg-accentYellow text-white shadow-md"
          : "bg-white border-2 border-accentYellow text-accentYellow hover:bg-accentYellow/5"
      }`}
                  >
                    Online Payment
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      setPayment("cod");
                    }}
                    className={`flex-1 outline-none rounded-xl
      px-1 sm:px-7
      py-2
      text-[11px] sm:text-base
      leading-snug sm:leading-normal
      text-center whitespace-normal break-normal
      font-medium transition-all duration-200
      ${
        payment === "cod"
          ? "bg-accentYellow text-white shadow-md"
          : "bg-white border-2 border-accentYellow text-accentYellow hover:bg-accentYellow/5"
      }`}
                  >
                    Cash on Delivery
                  </button>
                </div>

                {userData && userData.wallet > 0 ? (
                  <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                    <p className="text-sm text-blue-800 text-center">
                      <strong>Wallet balance:</strong> {"\u20B9"}
                      {Math.round(userData.wallet)} available for checkout.
                    </p>
                  </div>
                ) : (
                  <div className="mt-4 p-3 bg-gray-50 border border-gray-200 rounded-lg">
                    <p className="text-sm text-gray-600 text-center">
                      <strong>Note:</strong> Wallet balance is not available for
                      this checkout.
                    </p>
                  </div>
                )}

                <div className="flex justify-center items-center">
                  <Button
                    type="button"
                    onClick={handlePayment}
                    disabled={isPlacingOrder}
                    text={
                      isPlacingOrder
                        ? "Placing Order..."
                        : `Confirm Order${amount > 0 ? ` - ${"\u20B9"}${amount.toFixed(0)}` : ""}`
                    }
                    className="mx-auto flex items-center justify-center gap-2 px-8 py-3 rounded-xl font-semibold bg-accentYellow text-white hover:bg-accentYellow/90"
                  />
                </div>

                {isPlacingOrder && (
                  <div className="flex flex-col items-center justify-center mt-4">
                    <div className="w-8 h-8 border-4 border-accentYellow border-t-transparent rounded-full animate-spin mb-2"></div>
                    <p className="text-sm text-gray-600">
                      Placing your order...
                    </p>
                  </div>
                )}
              </div>
            </section>
          </div>
        </form>

        <div className="mt-8 overflow-hidden rounded-t-[32px] bg-white shadow-[0_-10px_30px_rgba(177,146,90,0.05)]">
          <Footer />
        </div>

        {/* App Download Modal */}
        <div
          className={
            showNote
              ? "fixed top-0 left-0 h-screen w-screen flex items-center justify-center z-[60] bg-black/40 opacity-100 duration-100 pointer-events-auto"
              : "duration-100 pointer-events-none opacity-0 fixed top-0 left-0 h-screen w-screen flex items-center justify-center z-[60] bg-black/40"
          }
        >
          <div className="w-[80vw] max-w-md rounded-lg bg-white p-6 shadow-2xl lg:w-[40vw] lg:max-w-4xl">
            <div className="flex justify-between items-center mb-4">
              <h1 className="text-xl text-left w-full font-bold">
                Download Our App
              </h1>
              <span
                className="cursor-pointer bg-gray-50 hover:bg-gray-100 duration-200 h-8 w-8 flex justify-center items-center rounded-md"
                onClick={() => {
                  setShowNote(false);
                  window.location.reload();
                }}
              >
                <IoIosClose className="text-3xl" />
              </span>
            </div>
            <div className="flex flex-col py-2 lg:flex-row lg:items-start lg:justify-between">
              <div className="flex-1">
                <h2 className="mb-3 text-base">
                  For the best experience, download our app and track your
                  orders in real-time!{" "}
                </h2>
                <div className="flex items-center justify-center gap-4 lg:justify-start">
                  <a
                    href="https://apps.apple.com/in/app/instaport-delivery/id6751334012"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:scale-105 transition-transform"
                  >
                    <img
                      src="/assets/footer/appstore.png"
                      alt="Download on the App Store"
                      className="h-12 hover:opacity-80 transition-opacity"
                    />
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.instaport.customer"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:scale-105 transition-transform"
                  >
                    <img
                      src="/assets/footer/playstore.png"
                      alt="Get it on Google Play"
                      className="h-12 hover:opacity-80 transition-opacity"
                    />
                  </a>
                </div>
              </div>
              <img
                src="/assets/QR/QR.jpeg"
                alt="Instaport app QR code"
                className="hidden lg:block h-24 w-24 shrink-0 self-start object-contain"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CreateOrder;
